import {
  getStandardSignatureRect,
  isStandardSignPosition,
} from 'src/app/shared-components/signature-position.util';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { CookieService } from 'ngx-cookie-service';
import { Location } from '@angular/common';
import { CatUploadService } from 'src/app/services/cat-upload.service';
import { TableColumn } from 'src/app/shared-components/data-table/data-table.component';
import { MessageService } from 'primeng/api';
import { EstampService } from 'src/app/services/estamp.service';
import moment from 'moment/moment';
import { StorageService } from 'src/app/services/storage.service';
import { OrderConfirmationDetailsComponent } from 'src/app/shared-components/order-confirmation-details/order-confirmation-details.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ExcelDataValidator } from 'src/app/models/excel-validation';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import { forEach, includes, result } from 'lodash';
import { OrderService } from 'src/app/services/order.service';
import { ConfirmationService, ConfirmEventType } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { CatEditService } from 'src/app/services/cat-edit.service';
import { ESignService } from 'src/app/services/e-sign.service';
import { error } from 'jquery';
import { UserManagementService } from 'src/app/services/user-management.service';
import { WalletService } from 'src/app/services/wallet.service';
import { CAT_EXECUTION_UPLOAD_CONSTANTS } from 'src/app/models/cat-execution-upload.constant';
import { StampDenominationService } from 'src/app/services/stamp-denomination.service';
import {
  SIGNATURE_BOX_HEIGHT_PT,
  SIGNATURE_BOX_WIDTH_PT,
  fitSignatureBoxInPage,
} from 'src/app/shared-components/signature-box.util';

type AOA = any[][];
interface Coordinates {
  x1: number;
  x2: number;
  y1: number;
  y2: number;
}

interface PositionDetails {
  [key: string]: Coordinates[];
}
interface SignatureConfig {
  method: string;
  sign_position: string;
}

interface SignatureCoordinates {
  x1: number;
  x2: number;
  y1: number;
  y2: number;
}
@Component({
    selector: 'upload-documents',
    templateUrl: './upload-documents.component.html',
    styleUrls: ['./upload-documents.component.scss'],
    standalone: false
})
export class UploadDocumentsComponent implements OnInit, OnDestroy {
  readonly errorModalColumns: TableColumn[] = [
    {
      field: 'reference_number',
      header: 'Reference Number',
      width: '30%',
      cellStyle: { 'white-space': 'nowrap', overflow: 'hidden', 'text-overflow': 'ellipsis', display: 'block' },
    },
    {
      field: 'message',
      header: 'Error Message',
      width: '70%',
      cellStyle: { 'white-space': 'normal', 'word-break': 'break-word' },
    },
  ];

  readonly estampPreviewColumns: TableColumn[] = [
    { field: 'referance_id', header: 'Reference ID' },
    { field: 'branch_code', header: 'Branch Code' },
    { field: 'first_party_name', header: 'First Party' },
    { field: 'second_party_name', header: 'Second Party' },
    { field: 'stamp_duty_paid_by', header: 'Stamp Duty Paid By' },
    { field: 'stamp_duty_amount', header: 'Stamp Duty Amount' },
    { field: 'description', header: 'Description' },
    { field: 'article_code', header: 'Article Id' },
    { field: 'consideration_amount', header: 'Consideration Amount' },
    { field: 'execution_date', header: 'Execution Date' },
    { field: 'update_by', header: 'Update by' },
  ];

  readonly esignPreviewColumns: TableColumn[] = [
    { field: 'reference_id', header: 'Reference ID' },
    { field: 'branch_code', header: 'Branch Code' },
    { field: 'name', header: 'Name' },
    { field: 'email', header: 'Email' },
    { field: 'contact_number', header: 'Contact Number' },
    { field: 'sign_position', header: 'Sign Position' },
    { field: 'method', header: 'Method' },
    { field: 'pages', header: 'Pages' },
    { field: 'user_type', header: 'User Type' },
  ];

  @ViewChild('reviewOrder') reviewOrder: TemplateRef<any>;
  hideBranch: boolean = false;
  branches: any;
  fileName: any = 'Selected File';
  productDetails: FormGroup;
  selectedDocumentType = '';
  uploadFile!: File;
  showTemplatePage: boolean = false;
  showUploadPage: boolean = true;
  selectFile: any;
  chooseFile: boolean = false;
  DATE_FORMAT = 'YYYY-MM-DD';
  @ViewChild('closeUploadPopupBtn') closeUploadPopupBtn!: ElementRef;
  @ViewChild('closePaymentPopupBtn') closePaymentPopupBtn!: ElementRef;
  submitted: boolean = false;
  @Input() uploadDocumentsData: any;
  @Output() uploadDocsChange: EventEmitter<any> = new EventEmitter<[]>();
  isDocUploaded: boolean = false;
  excelData: any = [];
  keys: any;
  dbColumnsMap: any;
  totalExcelRecords: any;
  totalListNumber: any;
  totalRecordsData: any;
  dataUploaded: boolean = false;
  storeImportedFileData: any;
  fileUploaded: any;
  estampHeaders = [
    'referance_id',
    'branch_code',
    'first_party_name',
    'second_party_name',
    'stamp_duty_paid_by',
    'stamp_duty_amount',
    'description',
    'article_code',
    'consideration_amount',
    'execution_date',
    'update_by',
  ];
  bothServiceHeaders = [
    'referance_id',
    'branch_code',
    'first_party_name',
    'second_party_name',
    'stamp_duty_paid_by',
    'stamp_duty_amount',
    'description',
    'article_code',
    'consideration_amount',
    'execution_date',
    'name',
    'email',
    'contact_number',
    'sign_position',
    'method',
    'pages',
  ];
  esignHeaders = [
    'referance_id',
    'branch_code',
    'name',
    'email',
    'contact_number',
    'sign_position',
    'method',
    'pages',
  ];
  excelHeaders = [];
  data: AOA = [
    [1, 2],
    [3, 4],
  ];
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  coloumData: any = [];
  headers: any;
  showFileName: boolean = false;
  convertedData: any = [];
  eSignDetails: any = {};
  eStampDetails: any = {
    is_bulk: 1 == 1,
    order_details: [],
  };
  eStampBulkDetails: any = {
    is_bulk: 1 == 1,
    order_details: [],
  };

  partyDeatils: any = [];
  withnessDetails: any = [];
  uploadDetails: any = {};
  estampData: any = [];
  esignData: any = [];
  showUploadOptions: boolean = false;
  showEsign: boolean = false;
  showEtamp: boolean = false;
  showBoth: boolean = false;
  isFileSubmitted: boolean = false;
  esignDetailsDataFromFile: any;
  catUploadStampBulkDetails: any;
  catUploadSignBulkDetails: any = {};
  catUploadEsignAndEstampBulkDetails: any = {};
  @ViewChild('orderDetails') orderDetails!: OrderConfirmationDetailsComponent;
  total_order = 0;
  totalStampAmount = 0;
  totalStampAmountForPopup = 0;
  totalPayableAmount = 0;
  aadhaarCount = 0;
  electronicCount = 0;
  dscCount = 0;
  stampCount = 0;
  totalConvFee = 0;
  GSTOnTotalBill = 0;
  issueList = [];
  selectedFile: any;
  fileApproved = false;
  excelRowsObjArr: any[];
  branchList: any[];
  branchCodeList: any = [];
  userName: string;
  isFileUpload: boolean = false;
  rowsWithIssues: any[];
  selectedBranch: any;
  showbulk_estamp: boolean = false;
  showbulk_esign: boolean = false;
  showUploadButton: boolean = false;
  errorBranchList: any[];
  serviceType: string = 'E-Sign';
  stampValidation: any = [];
  rowNumberIssue: any = [];
  rowstoDisplay: any = [];
  totalPages: number;
  userData: any;
  userProfileData: any;
  selectedReviewer: any;
  ElectrnicPostionDetails = [
    { position: 'BOTTOM_LEFT', loc: { x1: 6, y1: 779, x2: 156, y2: 829 } },
    {
      position: 'BOTTOM_LEFT_MIDDLE',
      loc: { x1: 156, y1: 779, x2: 226, y2: 829 },
    },
    { position: 'BOTTOM_CENTRE', loc: { x1: 226, y1: 779, x2: 376, y2: 829 } },
    { position: 'BOTTOM_CENTER', loc: { x1: 226, y1: 779, x2: 376, y2: 829 } },
    {
      position: 'BOTTOM_RIGHT_MIDDLE',
      loc: { x1: 376, y1: 779, x2: 462, y2: 829 },
    },
    { position: 'BOTTOM_RIGHT', loc: { x1: 462, y1: 779, x2: 612, y2: 829 } },
    { position: 'MIDDLE_LEFT', loc: { x1: 6, y1: 423, x2: 156, y2: 473 } },
    { position: 'MIDDLE_RIGHT', loc: { x1: 462, y1: 423, x2: 612, y2: 473 } },
    { position: 'TOP_LEFT', loc: { x1: 6, y1: 48, x2: 156, y2: 98 } },
    { position: 'TOP_CENTRE', loc: { x1: 235, y1: 48, x2: 385, y2: 98 } },
    { position: 'TOP_CENTER', loc: { x1: 235, y1: 48, x2: 385, y2: 98 } },
    { position: 'TOP_RIGHT', loc: { x1: 462, y1: 48, x2: 612, y2: 98 } },
    { position: 'BAILEE_1', loc: { x1: 399, y1: 695, x2: 500, y2: 760 } },
  ];
  AadhaarPostionDetails = [
    { position: 'BOTTOM_LEFT', loc: { x1: 6, y1: 48, x2: 156, y2: 98 } },
    {
      position: 'BOTTOM_LEFT_MIDDLE',
      loc: { x1: 156, y1: 48, x2: 235, y2: 98 },
    },
    { position: 'BOTTOM_CENTRE', loc: { x1: 235, y1: 48, x2: 385, y2: 98 } },
    { position: 'BOTTOM_CENTER', loc: { x1: 235, y1: 48, x2: 385, y2: 98 } },
    {
      position: 'BOTTOM_RIGHT_MIDDLE',
      loc: { x1: 385, y1: 48, x2: 462, y2: 98 },
    },
    { position: 'BOTTOM_RIGHT', loc: { x1: 462, y1: 48, x2: 612, y2: 98 } },
    { position: 'MIDDLE_RIGHT', loc: { x1: 462, y1: 423, x2: 612, y2: 473 } },
    { position: 'MIDDLE_LEFT', loc: { x1: 6, y1: 423, x2: 156, y2: 473 } },
    { position: 'TOP_LEFT', loc: { x1: 6, y1: 779, x2: 156, y2: 829 } },
    { position: 'TOP_CENTRE', loc: { x1: 235, y1: 779, x2: 385, y2: 829 } },
    { position: 'TOP_CENTER', loc: { x1: 235, y1: 779, x2: 385, y2: 829 } },
    { position: 'TOP_RIGHT', loc: { x1: 462, y1: 779, x2: 612, y2: 829 } },
    { position: 'BAILEE_1', loc: { x1: 370, y1: 70, x2: 530, y2: 170 } },
    {
      position: 'ATLAS_1_ABOVE',
      loc: {
        x1: 274,
        x2: 349,
        y1: 278,
        y2: 323,
      },
    },
    {
      position: 'ATLAS_1_BELOW',
      loc: {
        x1: 282,
        x2: 357,
        y1: 354,
        y2: 399,
      },
    },
    {
      position: 'ATLAS_2_ABOVE',
      loc: {
        x1: 221,
        x2: 296,
        y1: 234,
        y2: 279,
      },
    },
    {
      position: 'ATLAS_2_BELOW',
      loc: {
        x1: 336,
        x2: 411,
        y1: 334,
        y2: 379,
      },
    },
    {
      position: 'ATLAS_3',
      loc: {
        x1: 298,
        x2: 373,
        y1: 453,
        y2: 498,
      },
    },
  ];
  positionData: any;
  updateByStamp: any = [];
  userBranchList: any = [];
  branchCodeError: any = [];
  reviewDetails: FormGroup;
  reviewEmail: FormArray;
  validEmail: any;
  order_reviewer: any;
  showplaceOrder: boolean = false;
  otp_validation: boolean;
  base64File: any;
  pageHeight: number[];
  pageWidth: number[];
  excelDuplicate: any = [];
  referenceIdDuplicate: any = [];
  electronicPrice: number;
  dscPrice: number;
  aadhaarPrice: number;
  stampPrice: number;
  emailDuplicate: any = [];
  showEsignMethod: boolean = false;
  userId: any;
  virtualAccountNo: string;
  is_wallet: boolean = false;
  isDragging: boolean = false;
  fileSizeError: boolean = false;
  walletBalance: any;
  canWalletPayment: boolean = false;
  accountId: any;
  billingType: any;
  showProcessTypeDropdown: boolean = false;
  selectedStampProcessType: string =
    CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
  processTypeOptions: { label: string; value: string }[] = [];

  consolidatedErrors: any[] = [];
  validRowCount: number = 0;
  issuesSkipped: boolean = false;
  hasPanErrors: boolean = false;
  originalConvertedData: any = [];
  showErrorModal = false;
  excelDownloadLoading = false;
  errorModalData: {
    order_id?: number;
    reference_id?: string;
    errors_message_code?: Array<{
      error_code: string;
      reference_number: string;
      message: string;
    }>;
  } | null = null;

  constructor(
    private router: Router,
    private _location: Location,
    private cookieService: CookieService,
    private catUploadService: CatUploadService,
    private orderService: OrderService,
    private messageService: MessageService,
    private estampService: EstampService,
    private storageService: StorageService,
    private modalService: NgbModal,
    private userDashboardService: UserDashboardService,
    private confirmationService: ConfirmationService,
    private primengConfig: PrimeNG,
    private formBuilder: FormBuilder,
    private catEditService: CatEditService,
    private eSignService: ESignService,
    private userManagementService: UserManagementService,
    private cdr: ChangeDetectorRef,
    private walletService: WalletService,
    private stampDenominationService: StampDenominationService
  ) {
    this.otp_validation = this.storageService.getOtpValidation() ? true : false;
    this.order_reviewer = this.storageService.getOrderReviewConsent() || null;
    this.userId = this.storageService.getUserID() || null;
    if (this.userId) {
      this.editUserDetails(this.userId);
    }
    this.reviewDetails = this.formBuilder.group({
      reviewEmail: this.formBuilder.array([]),
      reviewer: [null],
    });

    if (this.catUploadService.uploadDocumentsDetails != undefined) {
      this.catUploadStampBulkDetails = {
        document: this.catUploadService.uploadDocumentsDetails.base64Doc,
        file_name: this.catUploadService.uploadDocumentsDetails.fileName,
        is_bulk: true,
        order_details: [],
      };
      this.catUploadSignBulkDetails = {
        document: this.catUploadService.uploadDocumentsDetails.base64Doc,
        file_name: this.catUploadService.uploadDocumentsDetails.fileName,
        is_bulk: true,
        order_details: [],
      };
      this.catUploadEsignAndEstampBulkDetails = {
        document: this.catUploadService.uploadDocumentsDetails.base64Doc,
        file_name: this.catUploadService.uploadDocumentsDetails.fileName,
        is_bulk: true,
        order_details: [],
      };

      this.totalPages = this.catUploadService.uploadDocumentsDetails.totalPages;
      this.pageHeight = this.catUploadService.uploadDocumentsDetails.pageHeight;
      this.pageWidth = this.catUploadService.uploadDocumentsDetails.pageWidth;
    }

    this.productDetails = this.formBuilder.group({
      branchName: ['Selected Branch', [Validators.required]],
      documentType: [false],
    });

    this.userName = this.storageService.getUser() || null;
    this.virtualAccountNo = this.storageService.getVirtualAccountNumber();
    this.is_wallet = this.storageService.getIsWallet();
    this.accountId = this.storageService.getAccountId();

    setTimeout(() => {
      this.userDashboardService.getBranchList().subscribe((res: any) => {
        this.branchList = res['content'].filter((el: any) => el.is_active === true);
        this.branchList.forEach((el: any) => this.userBranchList.push(el.branch_code));
      });
    }, 1000);

  }

  ngOnChanges(): void {
    let organization_id = this.storageService.getOrganizationId() || null;
    this.catUploadService
      .getPricingDetails(organization_id)
      .subscribe((res) => {
        this.electronicPrice = res.content.esign.electronic;
        this.dscPrice = res.content.esign.dsc;
        this.aadhaarPrice = res.content.esign.aadhaar;
        this.stampPrice = res.content.estamp;
        this.billingType = res.content.billing;
      });
  }

  ngOnDestroy(): void {
    console.log('Destroying the component');
  }

  ngOnInit(): void {
    this.primengConfig.ripple.set(true);

    this.selectedBranch = this.storageService.getBranch() || null;
    if (this.selectedBranch?.name) {
      this.productDetails.controls['branchName'].setValue(this.selectedBranch.name);
    }

    const path = this._location.path();
    if (path === '/doqfy/bulk-upload/form/cat-upload') {
      this.showUploadOptions = true;
      this.serviceType = 'E-Sign';
      this.showUploadButton = true;
      this.productDetails.controls['branchName'].setValue(this.selectedBranch?.name);
    } else if (path === '/doqfy/bulk-upload/form/e-sign') {
      this.showUploadOptions = false;
      this.showUploadButton = true;
      this.serviceType = CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESIGN;
      this.showEsignMethod = true;
      this.productDetails.controls['branchName'].setValue(this.selectedBranch?.name);
    } else {
      this.serviceType = CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESTAMP;
      this.showProcessTypeDropdown = false;
      this.selectedStampProcessType = CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
      this.loadProcessTypeOptions(); 
    }

    this.storageService.branchChange.subscribe((branch: any) => {
      this.selectedBranch = branch;
      this.productDetails.controls['branchName'].setValue(branch?.name);
      // If on E-Stamp path, reload process types for new branch/state
      if (this._location.path() !== '/doqfy/bulk-upload/form/cat-upload' &&
          this._location.path() !== '/doqfy/bulk-upload/form/e-sign') {
        this.loadProcessTypeOptions();
      }
    });

    if (this.is_wallet) {
      this.getRealWalletBalance(this.virtualAccountNo);
    } else {
      this.getDummyWalletBalance(this.accountId);
    }

    window.addEventListener('beforeunload', () => {
      localStorage.setItem('currentPage', this._location.path());
    });
    window.addEventListener('load', () => {
      const currentPage = localStorage.getItem('currentPage');
      if (currentPage) {
        switch (currentPage) {
          case '/doqfy/bulk-upload/form/cat-upload':
            this.router.navigate(['doqfy/cat-execution/form']); break;
          case '/doqfy/bulk-upload/form/e-sign':
            this.router.navigate(['doqfy/e-sign/form']); break;
        }
        localStorage.removeItem('currentPage');
      }
    });
  }

  get isPrepaid(): boolean {
    return (
      this.is_wallet &&
      this.billingType === CAT_EXECUTION_UPLOAD_CONSTANTS.BILLING_TYPE_PREPAID
    );
  }

  get isPostpaid(): boolean {
    return (
      this.is_wallet &&
      this.billingType === CAT_EXECUTION_UPLOAD_CONSTANTS.BILLING_TYPE_POSTPAID
    );
  }

  editUserDetails(id: any) {
    this.userManagementService.getUsersDetailsById(id).subscribe((res: any) => {
      this.userProfileData = res['content'][0];

      if (this.userProfileData.id === Number(id)) {
        this.branches = this.userProfileData.branch_codes;
      }
    });
  }

  excelOption(value: any) {
    this.serviceType = value;
    this.cancelUpload();

      this.showProcessTypeDropdown =
        value === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESTAMP ||
        value === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_BOTH;

      if (this.showProcessTypeDropdown) {
        this.showUploadButton = false;
        this.loadProcessTypeOptions();
      } else {
        this.showUploadButton = true;
      }
  }

  openUploadDocPopup() {
    this.fileName = 'Selected File';
    this.showFileName = false;
    this.isFileUpload = false;
    this.showbulk_esign = false;
    this.showbulk_estamp = false;
    this.convertedData = [];
    this.issueList = [];
    this.clearFile();
    this.eStampBulkDetails.order_details = [];
  }

  gotoOrderConfirmationPage() {
    if (
      this.totalPayableAmount > 0 &&
      this.is_wallet &&
      !this.canWalletPayment
    ) {
      return;
    }
    this.closePaymentModal();
    this.uploadDocumentsData = this.productDetails.value;
    this.uploadDocumentsData.option = 'Complete';
    this.onSendProductDetails();
  }

  onSendProductDetails() {
    if (this._location.path() == '/doqfy/bulk-upload/form/cat-upload') {
      this.catUploadPlaceOrder();
    }

    if (this._location.path() == '/doqfy/bulk-upload/form/e-sign') {
      this.catUploadPlaceOrder();
    }

    if (this._location.path() == '/doqfy/bulk-upload/form/e-stamp') {
      this.serviceType = CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESTAMP;
      this.estampBulkOrderPlace();
    }
  }

  gotoDashboard() {
    this.router.navigate(['doqfy/dashboard']);
  }

  cancelUpload() {
    this.showFileName = false;
    this.closeUploadPopupBtn.nativeElement.click();
    this.fileName = 'Selected File';
    this.isFileUpload = false;
    this.issueList = [];
    this.rowsWithIssues = [];
    this.consolidatedErrors = [];
    this.issuesSkipped = false;
    this.validRowCount = 0;
    this.clearFile();
  }

  uploadSelFile() {
    if (this.issuesSkipped) {
      this.chooseFile = false;
      this.isDocUploaded = true;
      this.isFileSubmitted = true;
      this.closeUploadPopupBtn.nativeElement.click();
      return;
    }
    if (!this.selectedFile || !this.showFileName) {
        this.chooseFile = true;
        return;
    }
    if (
      this.referenceIdDuplicate.length > 0 ||
      this.emailDuplicate.length > 0 ||
      this.excelDuplicate.length > 0 ||
      this.issueList.length > 0 ||
      this.branchCodeError.length > 0 ||
      this.updateByStamp.length > 0
    ) {
      this.showFileName = false;
      this.closeUploadPopupBtn.nativeElement.click();
      this.fileName = 'Selected File';
      this.isFileUpload = false;
      this.issueList = [];
      this.rowsWithIssues = [];
      this.clearFile();
      } else {
        this.chooseFile = false;
        this.isDocUploaded = true;
        this.isFileSubmitted = true;

        this.closeUploadPopupBtn.nativeElement.click();
    }
  }

  removeFileName() {
    this.showFileName = false;
    this.closeUploadPopupBtn.nativeElement.click();
    this.fileName = 'Selected File';
    this.isFileUpload = false;
    this.issueList = [];
    this.rowsWithIssues = [];
    this.consolidatedErrors = [];
    this.issuesSkipped = false;
    this.validRowCount = 0;
    this.clearFile();
  }

  onFileChange(evt: any) {
    this.excelDuplicate = [];
    this.referenceIdDuplicate = [];
    this.emailDuplicate = [];
    this.showplaceOrder = false;
    this.issueList = [];
    this.updateByStamp = [];
    this.isFileUpload = true;
    this.fileSizeError = false;

    let files = evt.target.files;
    if (files.length > 0) {
    this.selectedFile = files[0];
    this.fileName = files[0].name;

    this.showFileName = true; 
    this.chooseFile = false; 
    }
    this.fileName = this.fileName.replace(/\s*\(\d+\)/, '');

    if (this.fileName) {
      const fileSize = files[0].size / 1024 / 1024;
      if (fileSize > 10) {
        this.fileSizeError = true;
        this.messageService.add({
          severity: 'warn',
          detail: 'File should be less than 10MB in size',
        });
        const inputElement = <HTMLInputElement>(
          document.getElementById('upload_file')
        );
        if (inputElement) {
          inputElement.value = null;
        }
        return;
      }

      let splitName = files[0].name.split('.');
      if (
        splitName[splitName.length - 1] !== 'xlsx' &&
        splitName[splitName.length - 1] !== 'xls'
      ) {
        this.messageService.add({
          severity: 'warn',
          detail: 'Not a valid Excel file. Please upload another one',
        });
        const inputElement = <HTMLInputElement>(
          document.getElementById('upload_file')
        );
        if (inputElement) {
          inputElement.value = null;
        }
        return;
      } else if (splitName.length > 2) {
        this.messageService.add({
          severity: 'warn',
          detail: 'File name should have only single extension',
        });
        const inputElement = <HTMLInputElement>(
          document.getElementById('upload_file')
        );
        if (inputElement) {
          inputElement.value = null;
        }
        return;
      }

      this.showFileName = true;
      this.chooseFile = false;
      this.fileSizeError = false;

      const target: DataTransfer = <DataTransfer>evt.target;
      if (target.files.length !== 1)
        throw new Error('Cannot use multiple files');
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        this.base64File = btoa(e.target.result);

        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        this.data = <AOA>XLSX.utils.sheet_to_json(ws, { header: 1 });
        const headersData: string[] = this.data[0];

        this.createTable(this.data);

        const jsonData: any[] = XLSX.utils.sheet_to_json(ws, { header: 1 });
        const headers: string[] = jsonData.shift() as string[];

        this.excelRowsObjArr = XLSX.utils.sheet_to_json(wb.Sheets[wsname]);

        this.convertedData = jsonData.reduce((acc, row) => {
          const rowData: any = {};
          headers.forEach((header, index) => {
            if (row[index] === undefined) {
              rowData[header] = '';
            } else {
              rowData[header] = row[index];
            }
          });

          if (
            rowData.account_id &&
            typeof rowData.account_id === 'string' &&
            rowData.account_id.trim().length <= 1
          ) {
            return acc;
          }

          acc.push(rowData);
          return acc;
        }, []);

        this.convertedData.forEach((obj) => {
          for (const prop in obj) {
            if (obj[prop] === '') {
              delete obj[prop];
            }
          }
        });

        this.convertedData = this.convertedData.filter(
          (obj) => Object.keys(obj).length !== 0
        );

        // Reset skip state and set initial valid count - FIX ADDED
        this.issuesSkipped = false;
        this.validRowCount = this.convertedData.length;

        this.convertedData.forEach((item, index) => {
          if (item.update_by) {
            const updateByLowerCase = item.update_by.toLowerCase();
            if (updateByLowerCase.startsWith('t')) {
              const data = { rowNumber: index + 2, type: 'Traditional' };
              this.stampValidation.push(data);
            }
          }
        });

        setTimeout(() => {
          this.excelDuplicate = [];
          this.convertedData.forEach((data, index) => {
            if (
              data.branch_code &&
              !this.branches
                .map((branch) => branch.toLowerCase())
                .includes(data.branch_code.toLowerCase())
            ) {
              const rowData = {
                rowNumber: index + 2,
                error: `Branch Code ${data.branch_code} is not Assigned to the User.`,
              };
              this.excelDuplicate.push(rowData);
            }
          });
          // **NEW VALIDATION: Check for decimal values in consideration_amount**
          this.convertedData.forEach((data, index) => {
            if (
              data.consideration_amount !== undefined &&
              data.consideration_amount !== null &&
              data.consideration_amount !== ''
            ) {
              const amount = data.consideration_amount.toString();
              if (amount.includes('.') || !Number.isInteger(Number(amount))) {
                const rowData = {
                  rowNumber: index + 2,
                  error: `Consideration Amount must be a whole number (no decimals allowed). Found: ${data.consideration_amount}`,
                };
                this.excelDuplicate.push(rowData);
              }
            }
          });

          // Payment Link & cc_emails bulk upload: validate payee fields and cc_emails per row
          const _ccEmailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          this.convertedData.forEach((data, index) => {
            const rowNumber = index + 2;
            const hasPayeeName    = !!(data.payee_name    && data.payee_name.toString().trim());
            const hasPayeeEmail   = !!(data.payee_email   && data.payee_email.toString().trim());
            const hasPayeeContact = !!(data.payee_contact && data.payee_contact.toString().trim());
            const anyPayee = hasPayeeName || hasPayeeEmail || hasPayeeContact;
            const allPayee = hasPayeeName && hasPayeeEmail && hasPayeeContact;
            // Payee data belongs to the order row (row with referance_id); signatory continuation rows must not have it
            const isOrderRow = !!(data.referance_id && data.referance_id.toString().trim());

            if (!isOrderRow && anyPayee) {
              const rowErr = { rowNumber, error: 'Payment Link details must be in the order row (the row with referance_id), not in signatory rows.' };
              this.issueList.push(rowErr);
            }
            if (isOrderRow && anyPayee && !allPayee) {
              const rowErr = { rowNumber, error: 'Incomplete Payment details: Payee Name, Payee Email, and Payee Contact are all required together.' };
              this.issueList.push(rowErr);
            }
            if (isOrderRow && allPayee) {
              if (!_ccEmailPattern.test(data.payee_email.toString().trim())) {
                const rowErr = { rowNumber, error: 'Invalid Payee Email format.' };
                this.issueList.push(rowErr);
              }
              const contact = data.payee_contact.toString().trim();
              if (contact.length !== 10 || !/^\d+$/.test(contact)) {
                const rowErr = { rowNumber, error: 'Payee Contact must be exactly 10 digits.' };
                this.issueList.push(rowErr);
              }
            }

            // cc_emails: only validate for E-Sign / Both; silently ignore for pure E-Stamp
            const isEsignOrBoth = this.serviceType === 'E-Sign' || this.serviceType === 'Both';
            if (isEsignOrBoth && data.cc_emails) {
              const rawCc: string[] = data.cc_emails.toString().split(',').map((e: string) => e.trim()).filter((e: string) => !!e);
              if (rawCc.length > 10) {
                this.issueList.push({ rowNumber, error: 'cc_emails cannot have more than 10 addresses.' });
              } else {
                const invalid = rawCc.filter((e: string) => !_ccEmailPattern.test(e));
                if (invalid.length > 0) {
                  this.issueList.push({ rowNumber, error: `Invalid cc_emails: ${invalid.join(', ')}` });
                }
                // Duplicate cc_emails in the same cell are not allowed
                const unique = new Set(rawCc.map((e: string) => e.toLowerCase()));
                if (unique.size !== rawCc.length) {
                  this.issueList.push({ rowNumber, error: 'cc_emails contains duplicate email addresses.' });
                }
              }
            }
          });

          this.consolidateErrors();
          this.cdr.detectChanges();
        }, 100);

        const uniqueReferenceId = new Set();
        const invalidRefIdPattern = /[^a-zA-Z0-9_ ]/;
        this.convertedData.forEach((data, index) => {
          if (data.referance_id) {
            const refId = data.referance_id
              .toString()
              .toLowerCase()
              .trim();

            if (invalidRefIdPattern.test(refId)) {
              this.referenceIdDuplicate.push({ rowNumber: index + 2, error: `Invalid reference_id at row ${index + 2}: "${data.referance_id}". Only alphanumeric characters, underscore (_) and space are allowed.` });
            } else if (uniqueReferenceId.has(refId)) {
              this.referenceIdDuplicate.push({ rowNumber: index + 2, error: `Duplicate reference_id: ${data.referance_id}` });
            } else {
              uniqueReferenceId.add(refId);
            }
          }
        });
        this.consolidateErrors();

        if (this.convertedData.length === 0) {
          this.messageService.add({
            severity: 'warn',
            detail: 'Excel file cannot be empty',
          });
          this.fileName = 'Selected File';
          this.isFileUpload = false;
          this.clearFile();
          return;
        }

        if (
          this.serviceType ===
          CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESTAMP
        ) {
          this.validateExcelData(this.serviceType, this.convertedData);
          this.setEstampAndEsign(this.convertedData);
        } else if (
          this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESIGN
        ) {
          this.validateExcelData(this.serviceType, this.convertedData);
          this.setEsignDataForValidation(this.convertedData);
        } else if (
          this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_BOTH
        ) {
          this.getOrderObjects(this.convertedData);
        } else {
          this.serviceType = CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESTAMP;
          this.validateExcelData(this.serviceType, this.convertedData);
          this.setEstampAndEsign(this.convertedData);
        }
        this.cdr.detectChanges();
        // --- NEW AUTO DOWNLOAD TRIGGER ---
        setTimeout(() => {
          if (this.convertedData.length !== 0 && this.consolidatedErrors.length > 0 && this.isFileUpload) {
            // console.log("Errors detected, triggering auto-download...");
            this.exportErrorsToExcel();
          }
        }, 1000); 
      };

      reader.readAsBinaryString(target.files[0]);
    }
  }

  hasAllKeys(obj, keys) {
    return keys.every((key) => key in obj);
  }

  setEsignDataForValidation(data) {
    const result: any[] = [];
    let currentArray: any[] = [];
    for (const obj of data) {
      if (obj.referance_id) {
        // Create a new array and push the current object into it
        currentArray = [obj];
        result.push(currentArray);
      } else {
        // Push the current object into the current array
        currentArray.push(obj);
      }
    }
    this.emailDuplicate = [];
    result.forEach((order, index) => {
      const emails = new Set<string>();
      const duplicates: string[] = [];

      order.forEach((user: any) => {
        const email = user.email;
        if (emails.has(email)) {
          duplicates.push(email);

          const rowData = {
            ReferanceId: order[0].referance_id,
            error: `Email ${email} should not be same in single Order`,
          };
          this.emailDuplicate.push(rowData);
        }
        emails.add(email);
      });
    });
    this.consolidateErrors();
    this.getEsignData(result);
  }

  getEsignData(data: any) {
    var orderdetails: any = [];
    data.forEach((order) => {
      //-------------------------------------------------------------------------------------------------------------------//
      const estampObject: any = [];
      let singleOrder: any = {};
      let signatoryDetailsData: any = [];
      let esignObjectData: any = {};
      const partySign: any = [];
      const withnessSign: any = [];
      let previousOrder: any;
      let esign_bill = [];
      let stamp_bill = [];
      let totalamount = 0;
      let esign_conv_fee = 0;
      order.forEach((obj) => {
        //--------------------Formetting Esign Values--------------------//

        if (obj.contact_number) {
          obj.contact_number = obj.contact_number.toString();
        }
        const esignParty = {
          name: obj.name,
          email: obj.email,
          contact_number: obj.contact_number,
          sign_position: obj.sign_position,
          method: obj.method.trim(),
          position_details: {},
          pages:
            typeof obj.pages === 'string' && obj.pages.toLowerCase() === 'all'
              ? 'ALL'
              : obj.pages,
          user_type: 'PARTY',
          esign_otp: this.otp_validation,
          send_document: true,
          send_notification: false,
          sign_method: obj.method.trim(),
          schedule_timestamp: '',
          signatory_sequence: 0,
          remark: '',
          reminder: 1,
        };
        if (esignParty.name != undefined) {
          partySign.push(esignParty);
        }

        obj.position_details = {};
        let pagesArray: string[] = [];

        if (typeof obj.pages === 'string') {
          const pages = obj.pages.toLowerCase();

          // Check if 'ALL' is selected
          if (pages === 'all') {
            pagesArray = ['ALL'];
          } else {
            // Split by comma and trim any potential whitespace
            pagesArray = pages.split(',').map((page) => page.trim());
          }
        } else if (typeof obj.pages === 'number') {
          // If it's a single number, convert it to an array
          pagesArray = [String(obj.pages)];
        }
        if (obj.method.trim().toUpperCase() === 'ELECTRONIC') {
          this.ElectrnicPostionDetails.forEach((ele) => {
            if (ele.position === obj.sign_position.toUpperCase()) {
              this.positionData = ele.loc;
              pagesArray.forEach((page) => {
                obj.position_details[page] = [{ ...this.positionData }];
              });
            }
          });
        } else if (
          obj.method.trim().toUpperCase() === 'AADHAAR' ||
          obj.method.trim().toUpperCase() === 'DSC'
        ) {
          this.AadhaarPostionDetails.forEach((ele) => {
            if (ele.position === obj.sign_position.toUpperCase()) {
              this.positionData = ele.loc;
              pagesArray.forEach((page) => {
                obj.position_details[page] = [{ ...this.positionData }];
              });
            }
          });
        }
        //---------------------------------------------------------------Page Height settings ----------------------------------//
        if (
          obj.method.trim().toUpperCase() === 'DSC' ||
          obj.method.trim().toUpperCase() === 'AADHAAR' ||
          obj.method.trim().toUpperCase() === 'ELECTRONIC'
        ) {
          for (let i = 1; i <= this.totalPages; i++) {
            if (obj.position_details['ALL']) {
              // If 'ALL' is present, apply the signature to all pages
              const coordinates: Coordinates[] = obj.position_details['ALL'];
              const newPositionDetails: PositionDetails = {};

              for (let j = 1; j <= this.totalPages; j++) {
                const pageHeight = this.pageHeight[j - 1]; // Indexed height for specific page
                const pageWidth = this.pageWidth[j - 1]; // Indexed width for specific page

                newPositionDetails[j.toString()] = coordinates.map((coord) => {
                  if (
                    obj.method.trim().toUpperCase() === 'AADHAAR' ||
                    obj.method.trim().toUpperCase() === 'DSC'
                  ) {
                    return this.calculateSignatureCoordinates(
                      {
                        method: obj.method.trim(),
                        sign_position: obj.sign_position,
                      },
                      pageWidth,
                      pageHeight
                    );
                  } else if (obj.method.trim().toUpperCase() === 'ELECTRONIC') {
                    return this.calculateElectronicSignaturePosition(
                      {
                        method: obj.method.trim(),
                        sign_position: obj.sign_position,
                      },
                      pageWidth,
                      pageHeight
                    );
                  }
                  return coord; // Return unmodified coordinates if condition is not met
                });
              }

              // Delete the 'ALL' key and assign new details
              delete obj.position_details['ALL'];
              Object.assign(obj.position_details, newPositionDetails);
            } else {
              const coordinates = obj.position_details[pagesArray[0]] || [];
              const newPositionDetails: PositionDetails = {};

              pagesArray.forEach((page) => {
                const pageNum = parseInt(page, 10);
                if (!isNaN(pageNum) && pageNum <= this.totalPages) {
                  const pageHeight = this.pageHeight[pageNum - 1];
                  const pageWidth = this.pageWidth[pageNum - 1];

                  newPositionDetails[pageNum.toString()] = coordinates.map(
                    () => {
                      if (
                        obj.method.trim().toUpperCase() === 'AADHAAR' ||
                        obj.method.trim().toUpperCase() === 'DSC'
                      ) {
                        return this.calculateSignatureCoordinates(
                          {
                            method: obj.method.trim(),
                            sign_position: obj.sign_position,
                          },
                          pageWidth,
                          pageHeight
                        );
                      } else if (
                        obj.method.trim().toUpperCase() === 'ELECTRONIC'
                      ) {
                        return this.calculateElectronicSignaturePosition(
                          {
                            method: obj.method.trim(),
                            sign_position: obj.sign_position,
                          },
                          pageWidth,
                          pageHeight
                        );
                      }
                      return coordinates[0]; // Return original coordinates if no conditions met
                    }
                  );
                }
              });

              // Merge the new position details with the object
              Object.assign(obj.position_details, newPositionDetails);
            }
          }
        }

        //--------------------------------------------------------------------------------------------//

        let details = {
          name: obj.name,
          email: obj.email,
          contact_number: obj.contact_number,
          position_details: obj.position_details,
          sign_position: obj.sign_position,
          pages:
            typeof obj.pages === 'string' && obj.pages.toLowerCase() === 'all'
              ? 'ALL'
              : obj.pages,
          signatory_sequence: 0,
          send_document: true,
          send_notification: false,
          method: obj.method.trim(),
          schedule_timestamp: '',
          esign_otp: this.otp_validation,
          remark: '',
          reminder: 1,
          // Payment Link & cc_emails bulk upload: cc_emails per signatory, sourced from the order's first row
          cc_emails: this.parseCcEmails(order[0]?.cc_emails || ''),
        };

        let esignMethod = obj.method.trim().toUpperCase();
        if (esignMethod) {
          let esign_price =
            esignMethod === 'AADHAAR'
              ? this.aadhaarPrice
              : esignMethod === 'DSC'
              ? this.dscPrice
              : this.electronicPrice;

          let esign_bill_obj = {
            sign_method: obj.method.trim(),
            price: this.isPrepaid ? esign_price : 0,
            amount: this.isPrepaid ? esign_price : 0,
            quantity: 1,
          };
          esign_conv_fee += esign_price;
          esign_bill.push(esign_bill_obj);
        }

        if (
          obj.sign_position.toUpperCase() === 'CHCOMPANY' ||
          obj.sign_position.toUpperCase() === 'PNEUMATIC' ||
          obj.sign_position.toUpperCase() === 'BAILEE_1' ||
          obj.sign_position.toUpperCase() === 'ATLAS_1_ABOVE' ||
          obj.sign_position.toUpperCase() === 'ATLAS_1_BELOW' ||
          obj.sign_position.toUpperCase() === 'ATLAS_2_ABOVE' ||
          obj.sign_position.toUpperCase() === 'ATLAS_2_BELOW' ||
          obj.sign_position.toUpperCase() === 'ATLAS_3'
        ) {
          details.sign_position = 'DRAG_DROP';
          partySign.sign_position = 'DRAG_DROP';
        }
        signatoryDetailsData.push(details);
        partySign.position_details = details.position_details;
        esignObjectData = {
          party_users: signatoryDetailsData,
          witness_users: withnessSign,
        };
        //-------------------- Creating OrderDetails ---------------------------------------//
        singleOrder = {
          esigns: esignObjectData,
          estamps: estampObject,
          referance_id: obj.referance_id,
          branch_code: obj.branch_code,
        };
        if (obj.account_id) {
          singleOrder.account_id = obj.account_id;
        }
        // Payment Link & cc_emails bulk upload: inject payment_data at order level if payee fields are filled
        const _esignPaymentData = this.buildPaymentData(order[0]);
        if (_esignPaymentData) {
          singleOrder.payment_data = _esignPaymentData;
        }
        if (singleOrder.referance_id) {
          orderdetails.push(singleOrder);

          previousOrder = singleOrder; // Store the current order object as the previous order
        } else if (!singleOrder.referance_id && !singleOrder.branch_code) {
          if (previousOrder) {
            previousOrder.esigns.party_users.push(
              ...esignObjectData.party_users
            );
            previousOrder.esigns.witness_users.push(
              ...esignObjectData.witness_users
            );
          }
        }
      });
      let totalAmount = esign_conv_fee;
      let GST = esign_conv_fee * 0.18;
      let totalAmountIncTax = Math.round((totalAmount + GST) * 100) / 100;
      if (this.is_wallet && this.isPrepaid) {
        previousOrder.wallet_data = {
          amount: totalAmountIncTax,
          stamp_rate: this.stampPrice,
          esign_rate: {
            electronic: this.electronicPrice,
            dsc: this.dscPrice,
            aadhaar: this.aadhaarPrice,
          },
          stamp_bill: stamp_bill,
          esign_bill: esign_bill,
          billing: this.billingType,
          virtual_account_no: this.virtualAccountNo,
        };
      }
    });
    orderdetails.forEach((singleOrder) => {
      singleOrder.esigns.party_users = Array.from(
        new Set(singleOrder.esigns.party_users)
      );
      singleOrder.esigns.witness_users = Array.from(
        new Set(singleOrder.esigns.witness_users)
      );
    });

    orderdetails = Array.from(new Set(orderdetails));
    this.setEstampAndEsign(orderdetails);
  }

  calculateSignatureCoordinates(
    sign: SignatureConfig,
    pageWidth: number,
    pageHeight: number
  ): SignatureCoordinates {
    if (sign.method !== 'AADHAAR' && sign.method !== 'DSC') {
      throw new Error('Invalid signature method');
    }

    pageWidth = Math.round(pageWidth);
    pageHeight = Math.round(pageHeight);

    // Standard positions use the shared calculation, so bulk orders place a
    // position exactly like every other flow.
    if (isStandardSignPosition(sign.sign_position)) {
      return getStandardSignatureRect(sign.method, sign.sign_position, pageWidth, pageHeight);
    }

    const isSmallPage = pageWidth < 500;

    // Same box on every page size and for every method (small pages used to
    // drop to 100x30).
    const signatureWidth = SIGNATURE_BOX_WIDTH_PT;
    const signatureHeight = SIGNATURE_BOX_HEIGHT_PT;
    const margin = Math.round(
      isSmallPage
        ? Math.min(3, pageWidth * 0.02)
        : Math.min(5, pageWidth * 0.01)
    );

    // Bottom-up (PDF) coordinates; only the anchor corner is worked out per
    // position, the far edges always follow from the fixed box size.
    const topY = pageHeight - signatureHeight - margin;
    const middleY = Math.max(
      margin,
      Math.round(pageHeight / 2 - signatureHeight / 2)
    );
    const leftX = margin;
    const centreX = Math.round(pageWidth / 2 - signatureWidth / 2);
    const rightX = pageWidth - signatureWidth - margin;

    let x1: number;
    let y1: number;

    switch (sign.sign_position) {
      case 'TOP_LEFT':
        x1 = leftX;
        y1 = topY;
        break;

      case 'TOP_CENTER':
      case 'TOP_CENTRE':
        x1 = centreX;
        y1 = topY;
        break;

      case 'TOP_RIGHT':
        x1 = rightX;
        y1 = topY;
        break;

      case 'MIDDLE_LEFT':
        x1 = leftX;
        y1 = middleY;
        break;

      case 'MIDDLE_RIGHT':
        x1 = rightX;
        y1 = middleY;
        break;

      case 'BOTTOM_LEFT':
        x1 = leftX;
        y1 = margin;
        break;

      case 'BOTTOM_CENTER':
      case 'BOTTOM_CENTRE':
        x1 = centreX;
        y1 = margin;
        break;

      case 'BOTTOM_RIGHT':
        x1 = rightX;
        y1 = margin;
        break;

      // The two middle bottom slots sit halfway between their neighbours. At a
      // third / two thirds of the page they overlapped the centre signature.
      case 'BOTTOM_LEFT_MIDDLE':
        x1 = Math.round((leftX + centreX) / 2);
        y1 = margin;
        break;

      case 'BOTTOM_RIGHT_MIDDLE':
        x1 = Math.round((centreX + rightX) / 2);
        y1 = margin;
        break;

      default:
        x1 = leftX;
        y1 = margin;
    }

    return fitSignatureBoxInPage(
      x1,
      y1,
      signatureWidth,
      signatureHeight,
      pageWidth,
      pageHeight
    );
  }

  calculateElectronicSignaturePosition(
    sign: SignatureConfig,
    pageWidth: number,
    pageHeight: number
  ): SignatureCoordinates {
    if (sign.method.toUpperCase() !== 'ELECTRONIC') {
      throw new Error('Invalid signature method: Must be ELECTRONIC');
    }

    pageWidth = Math.round(pageWidth);
    pageHeight = Math.round(pageHeight);

    // Standard positions use the shared calculation, so bulk orders place a
    // position exactly like every other flow.
    if (isStandardSignPosition(sign.sign_position)) {
      return getStandardSignatureRect(sign.method, sign.sign_position, pageWidth, pageHeight);
    }

    // Same box as every other placement/method (was 20% x 10% of the page).
    const signWidth = SIGNATURE_BOX_WIDTH_PT;
    const signHeight = SIGNATURE_BOX_HEIGHT_PT;
    const margin = Math.round(pageWidth * 0.01); // 1%

    // Top-down coordinates; only the anchor corner is worked out per position,
    // the far edges always follow from the fixed box size.
    let x1 = margin;
    let y1 = margin;

    const upperPosition = sign.sign_position.toUpperCase();

    // Set vertical position
    if (
      ['TOP_LEFT', 'TOP_CENTER', 'TOP_CENTRE', 'TOP_RIGHT'].includes(
        upperPosition
      )
    ) {
      y1 = margin;
    } else if (['MIDDLE_LEFT', 'MIDDLE_RIGHT'].includes(upperPosition)) {
      y1 = Math.round(pageHeight / 2 - signHeight / 2);
    } else if (
      [
        'BOTTOM_LEFT',
        'BOTTOM_CENTER',
        'BOTTOM_CENTRE',
        'BOTTOM_RIGHT',
        'BOTTOM_LEFT_MIDDLE',
        'BOTTOM_RIGHT_MIDDLE',
      ].includes(upperPosition)
    ) {
      y1 = pageHeight - (margin + signHeight);
    }

    const leftX = margin;
    const centreX = Math.round(pageWidth / 2 - signWidth / 2);
    const rightX = pageWidth - (margin + signWidth);

    // Set horizontal position
    switch (upperPosition) {
      case 'TOP_CENTER':
      case 'TOP_CENTRE':
      case 'MIDDLE_CENTER':
      case 'MIDDLE_CENTRE':
      case 'BOTTOM_CENTER':
      case 'BOTTOM_CENTRE':
        x1 = centreX;
        break;

      case 'TOP_RIGHT':
      case 'MIDDLE_RIGHT':
      case 'BOTTOM_RIGHT':
        x1 = rightX;
        break;

      // The two middle bottom slots sit halfway between their neighbours. At a
      // third / two thirds of the page they overlapped the centre signature.
      case 'BOTTOM_LEFT_MIDDLE':
        x1 = Math.round((leftX + centreX) / 2);
        break;

      case 'BOTTOM_RIGHT_MIDDLE':
        x1 = Math.round((centreX + rightX) / 2);
        break;

      // Default: keep left
      default:
        x1 = leftX;
    }

    // Kept on the page by moving it, never by trimming it.
    return fitSignatureBoxInPage(
      x1,
      y1,
      signWidth,
      signHeight,
      pageWidth,
      pageHeight
    );
  }

  getOrderObjects(data: any) {
    this.validateExcelData(this.serviceType, data);
    const result: any[] = [];
    let currentArray: any[] = [];
    for (const obj of data) {
      if (obj.referance_id) {
        // Create a new array and push the current object into it
        currentArray = [obj];
        result.push(currentArray);
      } else {
        // Push the current object into the current array
        currentArray.push(obj);
      }
    }

    // Combine objects in each currentArray into a single object
    this.emailDuplicate = [];
    result.forEach((order, index) => {
      const emails = new Set<string>();
      const duplicates: string[] = [];

      order.forEach((user: any) => {
        const email = user.email;
        if (emails.has(email)) {
          duplicates.push(email);

          const rowData = {
            ReferanceId: order[0].referance_id,
            error: `Email ${email} should not be same in single Order`,
          };
          this.emailDuplicate.push(rowData);
        }
        emails.add(email);
      });
    });
    this.consolidateErrors();
    this.setEstampAndEsign(result);
  }

  export(): void {
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.data);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  createTable(data: any) {
    this.coloumData = [];
    this.headers = data[0];
    for (let i = 1; i < data.length; i++) {
      if (data[i].length > 0) {
        this.coloumData.push(data[i]);
      }
    }

    this.cookieService.set('headerData', this.headers);
    this.cookieService.set('columnData', this.coloumData);
    this.cookieService.set('isBulkData', 'true');
  }

  setEstampAndEsign(data: any) {
    if (this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_BOTH) {
      this.showbulk_esign = true;
      this.showbulk_estamp = true;

      // Extract the first four properties into one object
      data.forEach((details: any) => {
        const {
          referance_id,
          branch_code,
          first_party_name,
          second_party_name,
          stamp_duty_paid_by,
          stamp_duty_amount,
          description,
          article_code,
          consideration_amount,
          execution_date,
          update_by,
          account_id,
          first_party_pan,
          second_party_pan,
          ...firstObject
        } = details;
        this.esignData.push(firstObject);
        // Extract the remaining properties into another object
        const secondObject = {
          referance_id,
          branch_code,
          first_party_name,
          second_party_name,
          stamp_duty_paid_by,
          stamp_duty_amount,
          description,
          article_code,
          consideration_amount,
          execution_date,
          update_by,
          first_party_pan: details.first_party_pan, 
          second_party_pan: details.second_party_pan,
          ...(account_id ? { account_id } : {}),
        };

        this.estampData.push(secondObject);
      });

      this.estampData = this.estampData.filter((obj) => {
        const values = Object.values(obj);
        return values.some((value) => value !== undefined);
      });

      this.esignData = this.esignData.filter((obj) => {
        const values = Object.values(obj);
        return values.some((value) => value !== undefined);
      });
    }

    //------------------Esign Api Pay load data---------------------------------------------//
    else if (
      this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESIGN
    ) {
      this.showbulk_esign = true;
      this.catUploadSignBulkDetails['order_details'] = data;
    }
    //-----------------------------------------------------------//
    //------------------EStamp Api Pay load data---------------------------------------------//
    else if (
      this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESTAMP
    ) {
      this.showbulk_estamp = true;

      const stamp_details = {
        stampsDetails: data,
      };

      this.eStampDetails = { stamp_details };

      //Estamp Order Payload
      let lastOrderDetails = null; // Initialize variable to store the last pushed order details

      data.forEach((estamp, index) => {
        let esign_bill = [];
        let stamp_bill = [];
        let totalamount = 0;
        let esign_conv_fee = 0;
        let stamp_conv_fee = 0;
        let total_stamp_duty_amount = 0;
        if (estamp.referance_id) {
          if (
            !lastOrderDetails ||
            lastOrderDetails.referance_id !== estamp.referance_id
          ) {
            lastOrderDetails = {
              branch_code: estamp.branch_code,
              referance_id: estamp.referance_id,
              estamps: [],
            };
            if (estamp.account_id) {
              lastOrderDetails.account_id = estamp.account_id;
            }

            // this.eStampBulkDetails['order_details'].push(lastOrderDetails);
          }

          lastOrderDetails.estamps.push({
            first_party_name: estamp.first_party_name,
            second_party_name: estamp.second_party_name,
            stamp_duty_paid_by: estamp.stamp_duty_paid_by,
            article_code: estamp.article_code,
            stamp_duty_amount: estamp.stamp_duty_amount,
            consideration_amount: estamp.consideration_amount,
            description: estamp.description,
            execution_date: this.dateEpochFormat(estamp.execution_date),
            process_type: this.selectedStampProcessType,
            update_by: estamp.update_by,
            first_party_pan: estamp.first_party_pan,
            second_party_pan: estamp.second_party_pan,
          });
          if (estamp.stamp_duty_amount) {
            let preProcurement =
              this.selectedStampProcessType ===
              CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
            let stamp_duty_amount = preProcurement
              ? 0
              : estamp.stamp_duty_amount;
            let stamp_price = preProcurement ? 0 : this.stampPrice;
            let stamp_bill_obj = {
              article_code: estamp.article_code,
              stamp_amount: stamp_duty_amount,
              price: this.isPrepaid ? stamp_price : 0,
              amount: stamp_duty_amount + (this.isPrepaid ? stamp_price : 0),
              quantity: 1,
            };
            total_stamp_duty_amount += stamp_duty_amount;
            stamp_conv_fee += stamp_price;
            stamp_bill.push(stamp_bill_obj);
          }
          totalamount += stamp_conv_fee + total_stamp_duty_amount;
          let GST = stamp_conv_fee * 0.18;
          let totalAmountIncTax = Math.round((totalamount + GST) * 100) / 100;
          if (this.is_wallet) {
            lastOrderDetails.wallet_data = {
              amount: this.isPrepaid
                ? totalAmountIncTax
                : total_stamp_duty_amount,
              stamp_rate: this.stampPrice,
              esign_rate: {
                electronic: this.electronicPrice,
                dsc: this.dscPrice,
                aadhaar: this.aadhaarPrice,
              },
              stamp_bill: stamp_bill,
              esign_bill: esign_bill,
              billing: this.billingType,
              virtual_account_no: this.virtualAccountNo,
            };
          }
          // Payment Link & cc_emails bulk upload: inject payment_data at order level (E-Stamp; cc_emails not applicable)
          const _estampPaymentData = this.buildPaymentData(estamp);
          if (_estampPaymentData) {
            lastOrderDetails.payment_data = _estampPaymentData;
          }
          this.eStampBulkDetails['order_details'].push(lastOrderDetails);
        }
      });
    }
    //-----------------------------------------------------------//
  }

  estampBulkOrderPlace() {
    if (this.isFileSubmitted) {
      this.serviceType = 'OnlyEstamp';

      if (this.order_reviewer) {
        // this.confirmOrder();
        this.onApproveMethod();
      } else {
        this.placeOrderBulk();
      }
    }
  }

  getOrderConfirmation(orderId) {
    var queryParams = {
      bulk_order_id: orderId,
      detail: 1,
    };
    this.orderService.getBulkOrders(queryParams).subscribe((res: any) => {
      if (res.status === 200) {
        //this.messageService.add({ severity: 'success', summary: 'Order Placed!', detail: res.message });
        this.catUploadService.orderDetails = {
          id: orderId,
          order_type: res.content[0].order_type,
          created: res.content[0].created,
          status_display: res.content[0].status_display,
          is_bulk: true,
        };
        this.orderDetails.getPlacedOrderDetails();
      }
    });
  }

  catUploadPlaceOrder() {
    if (this.isFileSubmitted) {
      if (
        this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_BOTH
      ) {
        this.catUploadEsignAndEstampBulkDetails['order_details'] = [];
        this.convertedData = this.convertedData.reduce((groups, item) => {
          let referanceId = item.referance_id;
          if (!referanceId) {
            referanceId = groups.lastreferanceId || '';
          } else {
            groups.lastreferanceId = referanceId;
          }
          if (!groups[referanceId]) {
            groups[referanceId] = [];
          }
          groups[referanceId].push(item);
          return groups;
        }, {});
        delete this.convertedData['lastreferanceId'];

        let obj;
        let e_obj;
        for (let key in this.convertedData) {
          obj = {
            referance_id: key,
            estamps: [],
            esigns: {
              party_users: [],
              witness_users: [],
            },
            //signatory_details: [],
          };
          let esign_bill = [];
          let stamp_bill = [];
          let totalamount = 0;
          let esign_conv_fee = 0;
          let stamp_conv_fee = 0;
          let total_stamp_duty_amount = 0;
          this.convertedData[key].forEach((element, index) => {
            //row---------------------------
            if (element.branch_code) obj['branch_code'] = element.branch_code;
            if (element.account_id) obj['account_id'] = element.account_id;
            if (element.contact_number) {
              element.contact_number = element.contact_number.toString();
            }
            e_obj = {
              name: element.name,
              email: element.email,
              contact_number: element.contact_number,
              sign_position: element.sign_position,
              method: element.method.trim(),
              position_details: {},
              pages:
                typeof element.pages === 'string' &&
                element.pages.toLowerCase() === 'all'
                  ? 'ALL'
                  : element.pages,
              esign_otp: this.otp_validation,
            };
            element.position_details = {};

            let pagesArray: string[] = [];

            if (typeof element.pages === 'string') {
              const pages = element.pages.toLowerCase();

              // Check if 'ALL' is selected
              if (pages === 'all') {
                pagesArray = ['ALL'];
              } else {
                // Split by comma and trim any potential whitespace
                pagesArray = pages.split(',').map((page) => page.trim());
              }
            } else if (typeof element.pages === 'number') {
              // If it's a single number, convert it to an array
              pagesArray = [String(element.pages)];
            }
            if (element.method.trim().toUpperCase() === 'ELECTRONIC') {
              this.ElectrnicPostionDetails.forEach((ele) => {
                if (ele.position === element.sign_position.toUpperCase()) {
                  this.positionData = ele.loc;
                  pagesArray.forEach((page) => {
                    element.position_details[page] = [{ ...this.positionData }];
                  });
                }
              });
            } else if (
              element.method.trim().toUpperCase() === 'AADHAAR' ||
              element.method.trim().toUpperCase() === 'DSC'
            ) {
              this.AadhaarPostionDetails.forEach((ele) => {
                if (ele.position === element.sign_position.toUpperCase()) {
                  this.positionData = ele.loc;
                  pagesArray.forEach((page) => {
                    element.position_details[page] = [{ ...this.positionData }];
                  });
                }
              });
            }

            //----------------------------------------Page Height ------------------------------------------//
            if (
              element.method.trim().toUpperCase() === 'DSC' ||
              element.method.trim().toUpperCase() === 'AADHAAR' ||
              element.method.trim().toUpperCase() === 'ELECTRONIC'
            ) {
              for (let i = 1; i <= this.totalPages; i++) {
                if (element.position_details['ALL']) {
                  const coordinates: Coordinates[] =
                    element.position_details['ALL'];
                  const newPositionDetails: PositionDetails = {};

                  for (let j = 1; j <= this.totalPages; j++) {
                    // Access the correct height and width for each page
                    const pageHeight = this.pageHeight[j - 1]; // Use indexed page height
                    const pageWidth = this.pageWidth[j - 1]; // Use indexed page width

                    newPositionDetails[j.toString()] = coordinates.map(
                      (coord) => {
                        if (
                          element.method.trim().toUpperCase() === 'AADHAAR' ||
                          element.method.trim().toUpperCase() === 'DSC'
                        ) {
                          return this.calculateSignatureCoordinates(
                            {
                              method: element.method.trim(),
                              sign_position: element.sign_position,
                            },
                            pageWidth,
                            pageHeight
                          );
                        } else if (
                          element.method.trim().toUpperCase() === 'ELECTRONIC'
                        ) {
                          return this.calculateElectronicSignaturePosition(
                            {
                              method: element.method.trim(),
                              sign_position: element.sign_position,
                            },
                            pageWidth,
                            pageHeight
                          );
                        }
                        return coord; // Return unmodified coordinates if condition is not met
                      }
                    );
                  }
                  delete element.position_details['ALL'];
                  Object.assign(element.position_details, newPositionDetails);
                } else {
                  const coordinates =
                    element.position_details[pagesArray[0]] || [];
                  const newPositionDetails: PositionDetails = {};

                  pagesArray.forEach((page) => {
                    const pageNum = parseInt(page, 10);
                    if (!isNaN(pageNum) && pageNum <= this.totalPages) {
                      const pageHeight = this.pageHeight[pageNum - 1];
                      const pageWidth = this.pageWidth[pageNum - 1];

                      newPositionDetails[pageNum.toString()] = coordinates.map(
                        () => {
                          if (
                            element.method.trim().toUpperCase() === 'AADHAAR' ||
                            element.method.trim().toUpperCase() === 'DSC'
                          ) {
                            return this.calculateSignatureCoordinates(
                              {
                                method: element.method.trim(),
                                sign_position: element.sign_position,
                              },
                              pageWidth,
                              pageHeight
                            );
                          } else if (
                            element.method.trim().toUpperCase() === 'ELECTRONIC'
                          ) {
                            return this.calculateElectronicSignaturePosition(
                              {
                                method: element.method.trim(),
                                sign_position: element.sign_position,
                              },
                              pageWidth,
                              pageHeight
                            );
                          }
                          return coordinates[0]; // Return original coordinates if no conditions met
                        }
                      );
                    }
                  });
                  // Merge the new position details with the object
                  Object.assign(element.position_details, newPositionDetails);
                }
              }
            }

            //----------------------------------------------------------------------------------------------------//

            let details = {
              name: element.name,
              email: element.email,
              contact_number: element.contact_number,
              position_details: element.position_details,
              sign_position: element.sign_position,
              pages: element.pages,
              signatory_sequence: 0,
              send_document: true,
              send_notification: false,
              method: element.method.trim(),
              schedule_timestamp: '',
              esign_otp: this.otp_validation,
              remark: '',
              reminder: 1,
              // Payment Link & cc_emails bulk upload: cc_emails per signatory from the order's first row
              cc_emails: this.parseCcEmails(this.convertedData[key][0]?.cc_emails || ''),
            };

            if (
              element.sign_position.toUpperCase() === 'CHCOMPANY' ||
              element.sign_position.toUpperCase() === 'PNEUMATIC' ||
              element.sign_position.toUpperCase() === 'BAILEE_1' ||
              element.sign_position.toUpperCase() === 'ATLAS_1_ABOVE' ||
              element.sign_position.toUpperCase() === 'ATLAS_1_BELOW' ||
              element.sign_position.toUpperCase() === 'ATLAS_2_ABOVE' ||
              element.sign_position.toUpperCase() === 'ATLAS_2_BELOW' ||
              element.sign_position.toUpperCase() === 'ATLAS_3'
            ) {
              details.sign_position = 'DRAG_DROP';
              obj['esigns']['party_users']['sign_position'] = 'DRAG_DROP';
            }
            //obj['signatory_details'].push(details);
            obj['esigns']['party_users']['position_details'] =
              details.position_details;
            obj['esigns']['party_users'].push(details);

            let esignMethod = element.method.trim().toUpperCase();
            if (esignMethod) {
              let esign_price =
                esignMethod === 'AADHAAR'
                  ? this.aadhaarPrice
                  : esignMethod === 'DSC'
                  ? this.dscPrice
                  : this.electronicPrice;

              let esign_bill_obj = {
                sign_method: element.method.trim(),
                price: this.isPrepaid ? esign_price : 0,
                amount: this.isPrepaid ? esign_price : 0,
                quantity: 1,
              };
              esign_conv_fee += esign_price;
              esign_bill.push(esign_bill_obj);
            }

            let estampObj = {
              first_party_name: element.first_party_name,
              second_party_name: element.second_party_name,
              stamp_duty_paid_by: element.stamp_duty_paid_by,
              article_code: element.article_code,
              stamp_duty_amount: element.stamp_duty_amount,
              consideration_amount: element.consideration_amount,
              description: element.description,
              execution_date: this.dateEpochFormat(element.execution_date),
              process_type: this.selectedStampProcessType,
              first_party_pan: element.first_party_pan,
              second_party_pan: element.second_party_pan,
            };

            if (element.stamp_duty_amount) {
              let preProcurement =
                this.selectedStampProcessType ===
                CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
              let stamp_duty_amount = preProcurement
                ? 0
                : element.stamp_duty_amount;
              let stamp_price = preProcurement ? 0 : this.stampPrice;
              let stamp_bill_obj = {
                article_code: element.article_code,
                stamp_amount: stamp_duty_amount,
                price: this.isPrepaid ? stamp_price : 0,
                amount: stamp_duty_amount + (this.isPrepaid ? stamp_price : 0),
                quantity: 1,
              };
              total_stamp_duty_amount += stamp_duty_amount;
              stamp_conv_fee += stamp_price;
              stamp_bill.push(stamp_bill_obj);
            }

            if (estampObj.second_party_name) {
              if (
                element.first_party_name !== '' ||
                element.second_party_name !== ''
              ) {
                obj['estamps'].push(estampObj);
              }
            }
          });
          totalamount +=
            esign_conv_fee + stamp_conv_fee + total_stamp_duty_amount;
          let GST = (esign_conv_fee + stamp_conv_fee) * 0.18;
          let totalAmountIncTax = Math.round((totalamount + GST) * 100) / 100;
          if (this.is_wallet) {
            obj.wallet_data = {
              amount: this.isPrepaid
                ? totalAmountIncTax
                : total_stamp_duty_amount,
              stamp_rate: this.stampPrice,
              esign_rate: {
                electronic: this.electronicPrice,
                dsc: this.dscPrice,
                aadhaar: this.aadhaarPrice,
              },
              stamp_bill: stamp_bill,
              esign_bill: esign_bill,
              billing: this.billingType,
              virtual_account_no: this.virtualAccountNo,
            };
          }
          // Payment Link & cc_emails bulk upload: inject payment_data at order level for Both service type
          const _bothPaymentData = this.buildPaymentData(this.convertedData[key][0]);
          if (_bothPaymentData) {
            (obj as any)['payment_data'] = _bothPaymentData;
          }
          this.catUploadEsignAndEstampBulkDetails['order_details'].push(obj);
        }
        if (this.order_reviewer) {
          // this.confirmOrder();
          this.onApproveMethod();
        } else {
          this.placeOrderBulk();
        }
      } else if (
        this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESTAMP
      ) {
        this.catUploadStampBulkDetails['order_details'] = [];
        this.eStampDetails.stamp_details.stampsDetails.forEach((estamp) => {
          let esign_bill = [];
          let stamp_bill = [];
          let totalamount = 0;
          let esign_conv_fee = 0;
          let stamp_conv_fee = 0;
          let total_stamp_duty_amount = 0;
          let totalAmountIncTax = 0;
          if (estamp.stamp_duty_amount) {
            let preProcurement =
              this.selectedStampProcessType ===
              CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
            let stamp_duty_amount = preProcurement
              ? 0
              : estamp.stamp_duty_amount;
            let stamp_price = preProcurement ? 0 : this.stampPrice;
            let stamp_bill_obj = {
              article_code: estamp.article_code,
              stamp_amount: stamp_duty_amount,
              price: this.isPrepaid ? stamp_price : 0,
              amount: stamp_duty_amount + (this.isPrepaid ? stamp_price : 0),
              quantity: 1,
            };
            total_stamp_duty_amount += stamp_duty_amount;
            stamp_conv_fee += stamp_price;
            stamp_bill.push(stamp_bill_obj);
            totalamount += stamp_duty_amount + stamp_price;
            let GST = stamp_conv_fee * 0.18;
            totalAmountIncTax = Math.round((totalamount + GST) * 100) / 100;
          }

          if (estamp.referance_id) {
            // Payment Link & cc_emails bulk upload: include payment_data at order level if payee fields present (cc_emails not applicable for E-Stamp)
            const _catStampPaymentData = this.buildPaymentData(estamp);
            this.catUploadStampBulkDetails['order_details'].push({
              branch_code: estamp.branch_code,
              referance_id: estamp.referance_id,
              ...(estamp.account_id ? { account_id: estamp.account_id } : {}),
              estamps: [
                {
                  first_party_name: estamp.first_party_name,
                  second_party_name: estamp.second_party_name,
                  stamp_duty_paid_by: estamp.stamp_duty_paid_by,
                  article_code: estamp.article_code,
                  stamp_duty_amount: estamp.stamp_duty_amount,
                  consideration_amount: estamp.consideration_amount,
                  description: estamp.description,
                  execution_date: this.dateEpochFormat(estamp.execution_date),
                  process_type: this.selectedStampProcessType,
                  first_party_pan: estamp.first_party_pan,
                  second_party_pan: estamp.second_party_pan,
                },
              ],
              esigns: {
                party_users: [],
                witness_users: [],
              },
              ...(this.is_wallet && {
                wallet_data: {
                  amount: this.isPrepaid
                    ? totalAmountIncTax
                    : total_stamp_duty_amount,
                  stamp_rate: this.stampPrice,
                  esign_rate: {
                    electronic: this.electronicPrice,
                    dsc: this.dscPrice,
                    aadhaar: this.aadhaarPrice,
                  },
                  stamp_bill: stamp_bill,
                  esign_bill: esign_bill,
                  billing: this.billingType,
                  virtual_account_no: this.virtualAccountNo,
                },
              }),
              ...(_catStampPaymentData ? { payment_data: _catStampPaymentData } : {}),
            });
          }
        });
        if (this.order_reviewer) {
          // this.confirmOrder();
          this.onApproveMethod();
        } else {
          this.placeOrderBulk();
        }
      } else if (
        this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESIGN
      ) {
        if (this.order_reviewer) {
          // this.confirmOrder();
          this.onApproveMethod();
        } else {
           this.placeOrderEsignBulk();
        }
      }
    }
  }

  // Payment Link & cc_emails bulk upload: parse comma-separated string into a deduped array
  private parseCcEmails(raw: any): string[] {
    if (!raw) return [];
    return [...new Set<string>(raw.toString().split(',').map((e: string) => e.trim()).filter((e: string) => e))];
  }

  // Payment Link & cc_emails bulk upload: build payment_data object if all three payee fields are present
  private buildPaymentData(row: any): { payee_name: string; payee_email: string; payee_contact: string } | null {
    const name    = row?.payee_name?.toString().trim();
    const email   = row?.payee_email?.toString().trim();
    const contact = row?.payee_contact?.toString().trim();
    if (name && email && contact) {
      return { payee_name: name, payee_email: email, payee_contact: contact };
    }
    return null;
  }

  placeOrderEsignBulk() {
  this.catUploadService
    .catUploadPlaceOrder(this.catUploadSignBulkDetails)  // Adjust payload as needed
    .subscribe({
      next: (res: any) => {
        // Success handling (same as other placeOrder methods)
        this.catUploadService.clearFormData();
        this.isFileSubmitted = false;
        
        if (res.content.bulk_id) {
          this.getOrderConfirmation(res.content.bulk_id);
          this.sendBulkExcelData(res.content.bulk_id, 'bulk');
        } else if (res.content.order_id) {
          this.getOrderConfirmation(res.content.order_id);
          this.sendBulkExcelData(res.content.order_id, 'order');
        }
        
        this.messageService.add({
          severity: 'success',
          summary: 'Order Placed!',
          detail: res.message,
        });
        
        setTimeout(() => {
          this.uploadDocsChange.emit(this.uploadDocumentsData);
        }, 2000);
      },
      error: (err) => {
        if (
          err.status === 400 &&
          err.error?.content?.order_id &&
          err.error?.content?.referance_id
        ) {
          this.showReferenceErrorModal(err.error.content);  // ✅ Shows modal
        } else {
          this.handleGenericError(err);
        }
      },
    });
}


  placeOrderUploadBoth() {
    this.catUploadService
      .catUploadPlaceOrder(this.catUploadEsignAndEstampBulkDetails)
      .subscribe({
        next: (res: any) => {
          if (res.status === 200) {
            this.catUploadService.clearFormData();
            this.isFileSubmitted = false;
            if (res.content.bulk_id) {
              this.getOrderConfirmation(res.content.bulk_id);
              this.sendBulkExcelData(res.content.bulk_id, 'bulk');
            } else if (res.content.order_id) {
              this.getOrderConfirmation(res.content.order_id);
              this.sendBulkExcelData(res.content.order_id, 'order');
            }
            this.messageService.add({
              severity: 'success',
              summary: 'Order Placed!',
              detail: res.message,
            });
            setTimeout(() => {
              this.uploadDocsChange.emit(this.uploadDocumentsData);
            }, 2000);
          }
        },
        error: (err) => {
          if (
            err.status === 400 &&
            err.error?.content?.order_id &&
            err.error?.content?.referance_id
          ) {
            // duplicate reference modal + auto Excel download
            this.showReferenceErrorModal(err.error.content);
          } else {
            // Handle other errors
            this.handleGenericError(err);
          }
        },
      });
  }

  placeOrderUploadEstamp() {
    this.catUploadService
      .catUploadPlaceOrder(this.catUploadStampBulkDetails)
      .subscribe({
        next: (res: any) => {
          if (res.status === 200) {
            this.catUploadService.clearFormData();
            this.isFileSubmitted = false;

            this.messageService.add({
              severity: 'success',
              summary: 'Order Placed!',
              detail: res.message,
            });
            setTimeout(() => {
              this.getOrderConfirmation(res.content.bulk_id);
              this.sendBulkExcelData(res.content.bulk_id, 'bulk');

              this.uploadDocsChange.emit(this.uploadDocumentsData);
            }, 2000);
          }
        },
        error: (err) => {
          if (
            err.status === 400 &&
            err.error?.content?.order_id &&
            err.error?.content?.referance_id
          ) {
            // Show duplicate reference modal + auto Excel download
            this.showReferenceErrorModal(err.error.content);
          } else {
            // Handle other errors
            this.handleGenericError(err);
          }
        },
      });
  }

  placeOrderUploadEsign() {
    if (this.showEsignMethod) {
      this.eSignService
        .sendEsignDetails(this.catUploadSignBulkDetails)
        .subscribe((res: any) => {
          if (res.status === 200) {
            this.isFileSubmitted = false;
            this.messageService.add({
              severity: 'success',
              summary: 'Order Placed!',
              detail: res.message,
            });
            setTimeout(() => {
              this.getOrderConfirmation(res.content.bulk_id);
              this.sendBulkExcelData(res.content.bulk_id, 'bulk');

              this.uploadDocsChange.emit(this.uploadDocumentsData);
            }, 2000);
          }
        });
    } else {
      this.catUploadService
        .catUploadPlaceOrder(this.catUploadSignBulkDetails)
        .subscribe((res: any) => {
          if (res.status === 200) {
            this.catUploadService.clearFormData();
            this.isFileSubmitted = false;
            this.messageService.add({
              severity: 'success',
              summary: 'Order Placed!',
              detail: res.message,
            });
            setTimeout(() => {
              this.getOrderConfirmation(res.content.bulk_id);
              this.sendBulkExcelData(res.content.bulk_id, 'bulk');

              this.uploadDocsChange.emit(this.uploadDocumentsData);
            }, 2000);
          }
        });
    }
  }

  placeOrderOnlyEstamp() {
    this.estampService.postEstampData(this.eStampBulkDetails).subscribe({
      next: (resp) => {
        if (resp.status == 200) {
          this.messageService.add({
            severity: 'success',
            summary: 'Placed!',
            detail: resp.message,
          });
          this.sendBulkExcelData(resp.content.bulk_id, 'bulk');
          setTimeout(() => {
            this.getOrderConfirmation(resp.content.bulk_id);
            this.uploadDocsChange.emit(this.uploadDocumentsData);
          }, 1000);
        }
      },
      error: (err) => {
        if (err.status === 400 && err.error?.content?.errors) {
          // Show modal with table instead of toast
          this.showReferenceErrorModal(err.error.content);
        } else {
          // Handle other errors normally
          this.handleGenericError(err);
        }
      },
    });
  }

  // Update showReferenceErrorModal method
  showReferenceErrorModal(content: any) {
    this.errorModalData = {
      order_id: content.order_id,
      reference_id: content.referance_id,
      errors_message_code: content.errors_message_code || [],
    };
    this.showErrorModal = true;

    // Auto download Excel after 1 second
    setTimeout(() => {
      this.downloadErrorExcel();
    }, 1000);
  }

  downloadErrorExcel() {
    this.excelDownloadLoading = true;

    const excelData = [
    ['Reference Number', 'Error Code', 'Error Message']
  ];

  // Add each error entry as a row
  this.errorModalData?.errors_message_code?.forEach((errorItem: any) => {
    excelData.push([
      errorItem.reference_number || '',
      errorItem.error_code || '',
      errorItem.message || ''
    ]);
  });
    const wsData = XLSX.utils.aoa_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsData, 'Reference_Errors');

    const fileName = `Error_Detected_${
      this.errorModalData?.order_id
    }_${new Date().getTime()}.xlsx`;
    XLSX.writeFile(wb, fileName);

    this.excelDownloadLoading = false;
  }

  handleGenericError(err: any) {
    // Your existing error handling logic
    this.messageService.add({
      severity: 'error',
      detail: err?.error?.message || 'Something went wrong',
    });
  }

  closeErrorModal() {
    this.showErrorModal = false;
    this.errorModalData = null;
  }

  //---------------------------------------------EpochFormat -----------------------------------------//
  dateEpochFormat(excelDate) {
    if (excelDate) {
      const dateString = excelDate.toString();

      if (dateString.includes('/')) {
        const [day, month, year] = excelDate.split('/').map(Number);
        const dateObject = new Date(year, month - 1, day);
        const epochTime = dateObject.getTime();
        return epochTime;
      } else if (dateString.includes('-')) {
        const [day, month, year] = excelDate.split('-').map(Number);
        const dateObject = new Date(year, month - 1, day);
        const epochTime = dateObject.getTime();
        return epochTime;
      } else if (dateString.includes('.')) {
        const dotDatePattern = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;
        if (dotDatePattern.test(dateString)) {
          const [day, month, year] = excelDate.split('.').map(Number);
          const dateObject = new Date(year, month - 1, day);
          const epochTime = dateObject.getTime();
          return epochTime;
        } else {
          excelDate = Math.floor(excelDate);
          const epochDiff = 25569;
          const date = new Date((excelDate - epochDiff) * 24 * 60 * 60 * 1000);
          this.addZeroTime(date);
          return date.getTime();
        }
      } else {
        excelDate = Math.floor(excelDate);
        const epochDiff = 25569;
        const date = new Date((excelDate - epochDiff) * 24 * 60 * 60 * 1000);
        this.addZeroTime(date);
        return date.getTime();
      }
    }
  }

  addZeroTime(date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
  }

  //-----------------------------------------------------------------------------------------------------//
  validateExcelData(serviceType, excelData) {
    this.rowsWithIssues = [];
    this.hasPanErrors = false;
    let branchCodeList = [];
    let errorBranchList = [];
    this.totalStampAmount = 0;
    this.totalStampAmountForPopup = 0;
    this.aadhaarCount = 0;
    this.electronicCount = 0;
    this.dscCount = 0;
    this.stampCount = 0;
    this.total_order = 0;

    for (let i = 0; i < excelData.length; i++) {
      const element = excelData[i];

      if (element.method) {
        const method = element.method.toLowerCase().trim();

        switch (method) {
          case 'aadhaar':
            this.aadhaarCount++;
            break;
          case 'electronic':
            this.electronicCount++;
            break;
          case 'dsc':
            this.dscCount++;
            break;
          default:
            console.warn(`Unknown method: "${element.method}" at row ${i + 1}`);
        }
      }

      branchCodeList.push(element.branch_code);
      let preProcurement =
        this.selectedStampProcessType ===
        CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
      if (element.stamp_duty_amount > 0) {
        if (element.stamp_duty_amount) {
          this.stampCount++;
        }
        this.totalStampAmount += preProcurement ? 0 : element.stamp_duty_amount;
        this.totalStampAmountForPopup += element.stamp_duty_amount;
      }
      if (element.referance_id) {
        this.total_order++;
      }
    }

    const validator = new ExcelDataValidator();
    const validationErrors = validator.validateExcelData(
      serviceType,
      excelData,
      this.rowsWithIssues
    );

    validationErrors.forEach((row) => {
      if (row.error.length > 0) {
        this.issueList.push(row);
      }
    });

    // PAN validation — ESBTR only
    if (this.selectedStampProcessType === CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ESBTR) {
      const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      const hasFirstPanCol  = excelData.some((row: any) => 'first_party_pan'  in row);
      const hasSecondPanCol = excelData.some((row: any) => 'second_party_pan' in row);

      if (!hasFirstPanCol) {
        this.hasPanErrors = true;
        this.issueList.push({ rowNumber: 'File', error: 'Column "first_party_pan" is missing. It is required for ESBTR process type.' });
      }
      if (!hasSecondPanCol) {
        this.hasPanErrors = true;
        this.issueList.push({ rowNumber: 'File', error: 'Column "second_party_pan" is missing. It is required for ESBTR process type.' });
      }

      excelData.forEach((row: any, index: number) => {
        const rowNumber = index + 2;
        if (hasFirstPanCol) {
          const val = row.first_party_pan?.toString().trim().toUpperCase();
          if (!val) {
            this.hasPanErrors = true;
            this.issueList.push({ rowNumber, error: 'first_party_pan is required for ESBTR process type.' });
          } else if (!panPattern.test(val)) {
            this.hasPanErrors = true;
            this.issueList.push({ rowNumber, error: `first_party_pan "${row.first_party_pan}" is invalid. Expected format: DNKPP7410P (5 letters, 4 digits, 1 letter).` });
          }
        }
        if (hasSecondPanCol) {
          const val = row.second_party_pan?.toString().trim().toUpperCase();
          if (!val) {
            this.hasPanErrors = true;
            this.issueList.push({ rowNumber, error: 'second_party_pan is required for ESBTR process type.' });
          } else if (!panPattern.test(val)) {
            this.hasPanErrors = true;
            this.issueList.push({ rowNumber, error: `second_party_pan "${row.second_party_pan}" is invalid. Expected format: DNKPP7410P (5 letters, 4 digits, 1 letter).` });
          }
        }
      });
    }

    this.stampValidation.forEach((stampItem) => {
      this.issueList.forEach((issueItem) => {
        if (stampItem.rowNumber === issueItem.rowNumber) {
          issueItem.error = issueItem.error
            .replace(
              'Execution Date should be in (dd-mm-yyyy) and  not be greater than the current date.',
              ''
            )
            .trim();
        }
      });
    });

    this.issueList.forEach((issueItem) => {
      issueItem.error = issueItem.error
        .replace(
          'Invalid or missing Referance ID. Invalid or missing Branch ID. Invalid or missing First Party Name. Invalid or missing Second Party Name. Invalid or missing Stamp Duty Paid By.Invalid or missing Stamp Duty Amount. Invalid or missing Description. Invalid or missing Article ID. Invalid or missing Consideration Amount. Invalid or missing Execution Date.',
          ''
        )
        .trim();
    });

    if (
      this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESIGN ||
      this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_BOTH
    ) {
      this.issueList.forEach((issueItem) => {
        issueItem.error = issueItem.error
          .replace(
            'Invalid or missing Referance ID. Invalid or missing Branch ID.',
            ''
          )
          .trim();
        issueItem.error = issueItem.error
          .replace(
            'Invalid or missing First Party Name. Invalid or missing Second Party Name. Invalid or missing Stamp Duty Paid By.Invalid or missing Stamp Duty Amount. Invalid or missing Description. Invalid or missing Article ID. Invalid or missing Consideration Amount.',
            ''
          )
          .trim();
      });
    }

    // Keep all non-empty errors in issueList for display
    this.issueList = this.issueList.filter((issueItem) => {
      return issueItem.error !== '';
    });

    // Build rowsWithIssues from issueList for display purposes
    this.rowsWithIssues = [];
    this.issueList.forEach((issue) => {
      const matchingRow = excelData.find((row, index) => {
        return index + 2 === issue.rowNumber;
      });
      if (matchingRow) {
        this.rowsWithIssues.push(matchingRow);
      }
    });

    // Branch code validation - NOW PROPERLY INTEGRATED
    this.excelDuplicate = [];
    this.convertedData.forEach((data, index) => {
      if (
        data.branch_code &&
        !this.branches
          .map((branch) => branch.toLowerCase())
          .includes(data.branch_code.toLowerCase())
      ) {
        const rowData = {
          rowNumber: index + 2,
          error: `Branch Code ${data.branch_code} is not Assigned to the User.`,
        };

        // Add to excelDuplicate
        this.excelDuplicate.push(rowData);

        // FIXED: Also add to issueList
        this.issueList.push(rowData);

        // FIXED: Add the row to rowsWithIssues
        if (!this.rowsWithIssues.includes(data)) {
          this.rowsWithIssues.push(data);
        }
      }
    });

    branchCodeList = Array.from(new Set(branchCodeList));
    this.branchCodeList = Array.from(new Set(branchCodeList));
    this.branchCodeList = this.branchCodeList.filter(
      (item) => item !== undefined
    );

    this.errorBranchList = Array.from(new Set(errorBranchList));
    this.rowsWithIssues = Array.from(new Set(this.rowsWithIssues));
    this.errorBranchList = this.errorBranchList.filter(
      (branchCode) => !branchCodeList.includes(branchCode)
    );
    this.errorBranchList.forEach((element) => {
      const stateCodeError = {
        error: 'Invalid or missing State Code :-  ' + element,
        rowNumber: 0,
      };
      this.issueList.push(stateCodeError);
    });
    this.consolidateErrors();

    // Calculate valid row count
    const allErrorRowNumbers = new Set<number>();
    const allErrorReferenceIds = new Set<string>();

    // Collect all error row numbers
    [
      this.issueList,
      this.excelDuplicate,
      this.referenceIdDuplicate,
      this.updateByStamp,
      this.branchCodeError,
    ].forEach((errorSource) => {
      errorSource.forEach((item) => {
        if (item.rowNumber) {
          allErrorRowNumbers.add(item.rowNumber);
        }
      });
    });

    // Collect reference IDs with errors (from email duplicates)
    this.emailDuplicate.forEach((item) => {
      if (item.ReferanceId) {
        allErrorReferenceIds.add(item.ReferanceId);
      }
    });

    // Count valid rows accurately
    let validRows = 0;
    let invalidRows = 0;

    this.convertedData.forEach((item, index) => {
      const excelRowNumber = index + 2;
      const hasRowNumberError = allErrorRowNumbers.has(excelRowNumber);
      const hasReferenceError =
        item.referance_id && allErrorReferenceIds.has(item.referance_id);

      if (hasRowNumberError || hasReferenceError) {
        invalidRows++;
      } else {
        validRows++;
      }
    });

    this.validRowCount = validRows;

    if (
      this.issueList.length > 0 ||
      this.excelDuplicate.length > 0 ||
      this.referenceIdDuplicate.length > 0 ||
      this.emailDuplicate.length > 0 ||
      this.updateByStamp.length > 0 ||
      this.branchCodeError.length > 0
    ) {
      this.clearFile();
    } else {
      this.fileApproved = true;
    }
  }

  clearFile() {
    this.selectedFile = '';
    const inputElement = <HTMLInputElement>(
      document.getElementById('upload_file')
    );
    inputElement.value = null;
  }

  openViewPopUp(content: TemplateRef<any>) {
    this.modalService.open(content, {
      size: 'xl',
      centered: true,
      scrollable: true,
      modalDialogClass: 'largeTableModal',
    });
  }

  viewOrders(content) {
    this.modalService
      .open(content, {
        size: 'lg',
        ariaLabelledBy: 'modal-basic-title',
      })
      .result.then(
        (result) => {},
        (reason) => {}
      );
  }

  viewIssues(content) {
    this.modalService
      .open(content, {
        size: 'lg',
        ariaLabelledBy: 'modal-basic-title',
      })
      .result.then(
        (result) => {},
        (reason) => {}
      );

       // 2. Trigger the download after 1 seconds
    //  setTimeout(() => {
    //      this.exportErrorsToExcel();
    //  }, 1000);
  }

    exportErrorsToExcel() {
      if (!this.consolidatedErrors || this.consolidatedErrors.length === 0) {
        return;
      }

  // 1. Use a Map to group error messages by Reference Number
   const errorMap = new Map<string, string[]>();

    this.consolidatedErrors.forEach((item) => {
    const refNumber = item.refId || 'N/A';
    
    // 2. Clean the error message: Remove "Row X :", "Row Row", and extra whitespace
    // This targets the "Row 5 :" clutter you wanted to remove
    let cleanMessage = item.displayText || '';
    
    // Regex to remove patterns like "Row 5 :", "Row - 5 :", or "Row Row - 5 :"
    cleanMessage = cleanMessage.replace(/^(Row\s*Row\s*-\s*\d+\s*:\s*|Row\s*-?\s*\d+\s*:\s*)/i, '').trim();

    // 3. Group messages by Reference Number
    if (!errorMap.has(refNumber)) {
      errorMap.set(refNumber, []);
    }
    
       // Only add if this specific error message isn't already in the list for this reference
       if (!errorMap.get(refNumber)?.includes(cleanMessage)) {
         errorMap.get(refNumber)?.push(cleanMessage);
       }
     });
   
     // 4. Transform Map into final Excel rows (One row per unique Reference ID)
     const dataToExport = Array.from(errorMap.entries()).map(([ref, messages]) => ({
       'Reference Number': ref,
       'Error Message': messages.join('; ') // Multiple errors separated by semicolon
     }));
   
     if (dataToExport.length === 0) return;
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);

      ws['!cols'] = [
        { wch: 25 }, 
        { wch: 85 }  
      ];
    
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Error List');
  
      XLSX.writeFile(wb, 'Error_Log.xlsx');
  }

  onApproveMethod() {
    this.reviewEmailArray().clear();
    this.addNewDetails();
    this.getUserDetails();

    this.modalService
      .open(this.reviewOrder, {
        // Use this.reviewOrder directly
        size: 'lg',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
  }

  closeModel() {
    this.modalService.dismissAll();
    this.reviewDetails.reset();
  }

  removeDetails(index: number) {
    this.reviewEmailArray().removeAt(index);
    this.reviewDetails.value.reviewer.splice(index, 1);
  }

  reviewEmailArray(): FormArray {
    return this.reviewDetails.get('reviewEmail') as FormArray;
  }

  addNewDetails() {
    this.reviewEmailArray().push(this.initDetails());
  }

  initDetails() {
    return this.formBuilder.group({
      email: new FormControl(null, [Validators.email]),
    });
  }
  goBack() {
    this.closeModel();
  }

  placeOrderBulk() {
    this.closeModel();
    if (this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_BOTH) {
      this.placeOrderUploadBoth();
    } else if (
      this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESTAMP
    ) {
      this.placeOrderUploadEstamp();
    } else if (
      this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESIGN
    ) {
      this.placeOrderUploadEsign();
    } else if (this.serviceType === 'OnlyEstamp') {
      this.placeOrderOnlyEstamp();
    }
  }

  sendBulkExcelData(id, value) {
    let data = {
      file_name: this.fileName,
      bulk_order_id: null,
      order_id: null,
      document: this.base64File,
    };
    if (value === 'bulk') {
      data.bulk_order_id = id;
    } else {
      data.order_id = id;
    }
    this.catEditService.sendExcelDocument(data).subscribe((res) => {});
  }

  placeOrderWithReview() {
    this.submitted = true;

    const reviewEmail = [];
    this.reviewDetails.value.reviewEmail.forEach((element) => {
      if (element.email) {
        reviewEmail.push(element.email);
      }
    });
    this.getEmailValid(reviewEmail);
  }

  getEmailValid(reviewEmail) {
    const data = { order_reviewers: reviewEmail };
    this.orderService.verifyApproverEmail(data).subscribe((res) => {
      this.validEmail = res['content'];
      if (this.validEmail.validated) {
        if (reviewEmail.length === 0) {
          this.messageService.add({
            severity: 'warn',
            detail: 'Please add atleast one Checker to Proceed',
          });
        } else {
          this.setReviewData(reviewEmail);
        }
      } else {
        this.messageService.add({
          severity: 'warn',
          detail: 'Please enter valid  Email for Checker',
        });
      }
    });
  }

  setReviewData(reviewEmail) {
    if (this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_BOTH) {
      this.catUploadEsignAndEstampBulkDetails.order_details.forEach(
        (element) => {
          element.order_reviewers = reviewEmail;
        }
      );
    } else if (
      this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESTAMP
    ) {
      this.catUploadStampBulkDetails.order_details.forEach((element) => {
        element.order_reviewers = reviewEmail;
      });
    } else if (
      this.serviceType === CAT_EXECUTION_UPLOAD_CONSTANTS.SERVICE_TYPE_ESIGN
    ) {
      this.catUploadSignBulkDetails.order_details.forEach((element) => {
        element.order_reviewers = reviewEmail;
      });
    } else if (this.serviceType === 'OnlyEstamp') {
      this.eStampBulkDetails.order_details.forEach((element) => {
        element.order_reviewers = reviewEmail;
      });
    }
    this.placeOrderBulk();
  }

  getUserDetails() {
    const account_id = this.storageService.getAccountId();
    this.orderService.getApproverEmail(account_id).subscribe((res) => {
      if (res.content.length != 0) {
        this.userData = res['content'];
      }
    });
  }

  selectReviewer() {
    this.selectedReviewer = this.reviewDetails.value.reviewer;

    this.reviewEmailArray().clear();
    this.selectedReviewer.forEach((element, index) => {
      this.addNewDetails();
      this.reviewEmailArray().at(index).get('email').setValue(element.email);
    });
    if (this.selectedReviewer.length === 0) {
      this.addNewDetails();
    }
  }

  calculateOrderPrice() {
    let preProcurement =
      this.selectedStampProcessType ===
      CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
    let stampPrice = preProcurement ? 0 : this.stampPrice;
    let totalAadhaarPrice =
      this.billingType === CAT_EXECUTION_UPLOAD_CONSTANTS.BILLING_TYPE_PREPAID
        ? this.aadhaarCount * this.aadhaarPrice
        : 0;
    let totalElectronicPrice =
      this.billingType === CAT_EXECUTION_UPLOAD_CONSTANTS.BILLING_TYPE_PREPAID
        ? this.electronicCount * this.electronicPrice
        : 0;
    let totalDscPrice =
      this.billingType === CAT_EXECUTION_UPLOAD_CONSTANTS.BILLING_TYPE_PREPAID
        ? this.dscCount * this.dscPrice
        : 0;
    let totalSignConvFee =
      totalAadhaarPrice + totalElectronicPrice + totalDscPrice;
    let totalStampConvFee =
      this.billingType === CAT_EXECUTION_UPLOAD_CONSTANTS.BILLING_TYPE_PREPAID
        ? this.stampCount * stampPrice
        : 0;

    let totalConvFee = totalSignConvFee + totalStampConvFee;

    this.totalConvFee = Math.round(totalConvFee * 100) / 100;
    let GSTOntotalBill = totalConvFee * 0.18;
    this.GSTOnTotalBill = Math.round(GSTOntotalBill * 100) / 100;
    this.totalStampAmount = Math.round(this.totalStampAmount * 100) / 100;
    this.totalPayableAmount =
      this.billingType === CAT_EXECUTION_UPLOAD_CONSTANTS.BILLING_TYPE_PREPAID
        ? this.totalStampAmount + this.totalConvFee + this.GSTOnTotalBill
        : this.totalStampAmount;
    this.totalPayableAmount = Math.round(this.totalPayableAmount * 100) / 100;
    if (this.walletBalance > this.totalPayableAmount) {
      this.canWalletPayment = true;
    } else {
      this.canWalletPayment = false;
    }
  }

  closePaymentModal(): void {
    this.closePaymentPopupBtn.nativeElement.click();
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      // Create a mock event object that matches the structure expected by onFileChange
      const mockEvent = {
        target: {
          files: files,
        },
      };

      // Call the existing onFileChange method with the dropped files
      this.onFileChange(mockEvent);
    }
  }

  getRealWalletBalance(virtual_account_no: any) {
    this.walletService.getWalletClientDetails(virtual_account_no).subscribe(
      (data: any) => {
        this.walletBalance = data.content.current_balance;
        this.storageService.setWalletBalance(data.content.current_balance);
        this.cdr.detectChanges();
      },
      (error: any) => {
        console.error('Error loading transactions:', error);
      }
    );
  }

  getDummyWalletBalance(account_id: any) {
    this.orderService.getBalance(account_id).subscribe(
      (data: any) => {
        this.walletBalance = data.content.current_balance;
        this.storageService.setWalletBalance(data.content.current_balance);
        this.cdr.detectChanges();
      },
      (error: any) => {
        console.error('Error loading transactions:', error);
      }
    );
  }

  onStampProcessTypeChange(event: any) {
    this.selectedStampProcessType = event.value;
    this.storageService.updateStampProcessType(event.value);
    this.removeFileName();
    console.log('Selected stamp process type:', event.value);

    if (this.selectedStampProcessType !== '') {
      this.showUploadButton = true;
    }
  }

  loadProcessTypeOptions(): void {
    const state = this.storageService.getState();
    if (!state?.state_code) {
      // No state yet — show all options, default to Inventory
      this.selectedStampProcessType = CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
      this.storageService.updateStampProcessType(this.selectedStampProcessType);
      this.processTypeOptions = [
        { label: 'Inventory', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT },
        { label: 'On The Fly', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ON_THE_FLY },
        { label: 'ESBTR',      value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ESBTR },
      ];
      this.cdr.detectChanges();
      return;
    }

    this.estampService.getStateDenomination({ state_code: state.state_code }).subscribe({
      next: (resp: any) => {
        if (resp?.status && resp['content']?.length > 0) {
          const stateInfo = resp['content'][0];
          const options: { label: string; value: string }[] = [];

          if (stateInfo.pre_estamp === true || stateInfo.traditional === true) {
            options.push({ label: 'Inventory', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT });
          }
          if (stateInfo.estamp === true) {
            options.push({ label: 'On The Fly', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ON_THE_FLY });
          }
          if (stateInfo.esbtr === true) {
            options.push({ label: 'ESBTR', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ESBTR });
          }

          const finalOptions = options.length > 0 ? options : [
            { label: 'Inventory', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT },
            { label: 'On The Fly', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ON_THE_FLY },
            { label: 'ESBTR',      value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ESBTR },
          ];

          // Set value BEFORE options so PrimeNG sees a matching value when options arrive
          const hasOnTheFly = finalOptions.some(o => o.value === CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ON_THE_FLY);
          this.selectedStampProcessType = hasOnTheFly
            ? CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ON_THE_FLY
            : CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
          this.storageService.updateStampProcessType(this.selectedStampProcessType);
          this.processTypeOptions = finalOptions;
          this.cdr.detectChanges();
        } else {
          // No data from API — show all 3, default to Inventory
          this.selectedStampProcessType = CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
          this.storageService.updateStampProcessType(this.selectedStampProcessType);
          this.processTypeOptions = [
            { label: 'Inventory', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT },
            { label: 'On The Fly', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ON_THE_FLY },
            { label: 'ESBTR',      value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ESBTR },
          ];
          this.cdr.detectChanges();
        }
      },
      error: () => {
        // On error — show all 3, default to Inventory
        this.processTypeOptions = [
          { label: 'Inventory', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT },
          { label: 'On The Fly', value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ON_THE_FLY },
          { label: 'ESBTR',      value: CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_ESBTR },
        ];
        this.selectedStampProcessType = CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;
        this.storageService.updateStampProcessType(this.selectedStampProcessType);
        this.cdr.detectChanges();
      }
    });
  }

  consolidateErrors() {
    const allErrors = [];
    const uniqueErrorMessages = new Set();

    // Helper function to add errors with proper formatting
    const addErrors = (errorArray, formatFunction) => {
      if (errorArray && errorArray.length > 0) {
        errorArray.forEach((item) => {
          const displayText = formatFunction(item);
          if (displayText && !uniqueErrorMessages.has(displayText)) {
            uniqueErrorMessages.add(displayText);
          
          // Determine Reference ID for Excel Column
          let refIdForExcel = 'N/A';
          
          // If item has rowNumber, get reference_id from the source data
          if (item.rowNumber && this.convertedData[item.rowNumber - 2]) {
            refIdForExcel = this.convertedData[item.rowNumber - 2].reference_id || 
                            this.convertedData[item.rowNumber - 2].referance_id || 'N/A';
          } 
          else if (item.ReferanceId) {
            refIdForExcel = item.ReferanceId;
          }
            allErrors.push({
              displayText: displayText,
              refId: refIdForExcel,   
              originalItem: item,
            });
          }
        });
      }
    };

    // Add errors from issueList (Row number + error)
    addErrors(this.issueList, (item) => {
      if (item.error) {
        return item.rowNumber
          ? `Row ${item.rowNumber} : ${item.error}`
          : item.error;
      }
      return null;
    });

    // Add errors from excelDuplicate (Row number + error)
    addErrors(this.excelDuplicate, (item) =>
      item.rowNumber && item.error
        ? `Row ${item.rowNumber} : ${item.error}`
        : null
    );

    // Add errors from referenceIdDuplicate (Row number + error)
    addErrors(this.referenceIdDuplicate, (item) =>
      item.rowNumber && item.error
        ? `Row ${item.rowNumber} : ${item.error}`
        : null
    );

    // Add errors from updateByStamp (Row number + error)
    addErrors(this.updateByStamp, (item) =>
      item.rowNumber && item.error
        ? `Row ${item.rowNumber} : ${item.error}`
        : null
    );

    // Add errors from branchCodeError (Row number + error)
    addErrors(this.branchCodeError, (item) =>
      item.rowNumber && item.error
        ? `Row ${item.rowNumber} : ${item.error}`
        : null
    );

    // Add errors from emailDuplicate (ReferenceId + error)
    addErrors(this.emailDuplicate, (item) =>
      item.ReferanceId && item.error
        ? `ReferenceId ${item.ReferanceId} : ${item.error}`
        : null
    );

    this.consolidatedErrors = allErrors;
  }
  skipAndContinue() {
    const errorRowNumbers = new Set<number>();
    const errorReferenceIds = new Set<string>();

    // Collect error row numbers from all error arrays
    const errorSourcesWithRow = [
      this.issueList,
      this.excelDuplicate,
      this.referenceIdDuplicate,
      this.updateByStamp,
      this.branchCodeError,
    ];

    errorSourcesWithRow.forEach((source) => {
      source.forEach((item) => {
        if (item.rowNumber) errorRowNumbers.add(item.rowNumber);
      });
    });

    // Collect reference IDs with email duplicates
    this.emailDuplicate.forEach((item) => {
      if (item.ReferanceId) {
        errorReferenceIds.add(item.ReferanceId);
      }
    });

    const isInvalidField = (item: any) => {
      const invalidBranch =
        item.branch_code &&
        !this.branches
          .map((branch) => branch.toLowerCase())
          .includes(item.branch_code.toLowerCase());
      const invalidArticle =
        item.article_code === '' || item.article_code === null;
      return invalidBranch || invalidArticle;
    };

    // Filter convertedData - keep only valid rows
    this.convertedData = this.convertedData.filter((item, index) => {
      const excelRowNumber = index + 2;
      const hasRowError = errorRowNumbers.has(excelRowNumber);
      const hasReferenceError =
        item.referance_id && errorReferenceIds.has(item.referance_id);
      const hasFieldErrors = isInvalidField(item);
      return !hasRowError && !hasReferenceError && !hasFieldErrors;
    });

    // Update valid row count
    this.validRowCount = this.convertedData.length;

    // Clear all error arrays
    this.issueList = [];
    this.excelDuplicate = [];
    this.referenceIdDuplicate = [];
    this.emailDuplicate = [];
    this.updateByStamp = [];
    this.branchCodeError = [];
    this.consolidatedErrors = [];

    // Recalculate excelRowsObjArr
    this.excelRowsObjArr = [...this.convertedData];

    // Recalculate branch codes from valid data
    this.branchCodeList = Array.from(
      new Set(
        this.convertedData
          .map((item) => item.branch_code)
          .filter((code) => code !== undefined)
      )
    );

    // Recalculate totals
    this.totalStampAmount = 0;
    this.totalStampAmountForPopup = 0;
    this.stampCount = 0;

    const preProcurement =
      this.selectedStampProcessType ===
      CAT_EXECUTION_UPLOAD_CONSTANTS.ORDER_TYPE_PREPROCUREMENT;

    this.convertedData.forEach((element) => {
      if (element.stamp_duty_amount > 0) {
        this.stampCount++;
        this.totalStampAmount += preProcurement ? 0 : element.stamp_duty_amount;
        this.totalStampAmountForPopup += element.stamp_duty_amount;
      }
    });

    // Round amounts
    this.totalStampAmount = Math.round(this.totalStampAmount * 100) / 100;
    this.totalStampAmountForPopup =
      Math.round(this.totalStampAmountForPopup * 100) / 100;

    // Clear and rebuild eStampBulkDetails
    this.eStampBulkDetails.order_details = [];

    // Rebuild the order details with filtered data
    this.setEstampAndEsign(this.convertedData);

    // Set flags
    this.isFileSubmitted = true;
    this.fileApproved = true;
    this.issuesSkipped = true;

    // Close the issues modal if open
    this.modalService.dismissAll();

    // Force change detection
    this.cdr.detectChanges();
  }

  validateStampDenominationFromBackend(excelData: any[]) {
    const groupedData = this.stampDenominationService.groupStampDenomination(
      excelData,
      {
        includeAccountId: true,
      }
    );

    const payload =
      this.stampDenominationService.mapToStampDenominationRequest(groupedData);

    this.estampService.getStampInventoryAndDenominationInfo(payload).subscribe({
      next: (response) => {
        this.stampDenominationService.handleStampDenominationErrors(
          response,
          groupedData,
          this.convertedData,
          this.issueList,
          this.rowsWithIssues,
          true
        );

        this.consolidateErrors();
      },
      error: (err) => {
        console.error('Stamp denomination validation failed', err);
      },
    });
  }
}